<template>
    <div class="card box widget-social pt-2 pb-2" :class="componentStyle">
        <widgetTitleBar :moduleData="this.moduleData" :widgetInfo="content" :alarmList="this.alarmList" :menu-items="this.items" @menu-click="($value) => this.toggle($value)"></widgetTitleBar>
        <OverlayPanel
            class="param-overlay"
            ref="alarmOverlay"
            appendTo="body"
            :autoZIndex="true"
            @show="focusElement" 
            :dismissable="true"
            :showCloseIcon="true"
            :breakpoints="{ '960px': '75vw', '640px': '90vw' }"
            :style="{ height: 'auto' }"
        >
            <div v-for="(element) in this.alarmList" :key="element.label">
                <span>🔴 {{ element.label }}</span>
            </div>
        </OverlayPanel>
        <div v-if="isLoading">
            <loader-skeleton :widgetInfo="content"></loader-skeleton>
        </div>
        <OverlayPanel class="param-overlay" ref="periods" appendTo="body" :autoZIndex="true" @show="focusElement" 
            :dismissable="false" :showCloseIcon="true" :breakpoints="{ '960px': '75vw', '640px': '90vw' }"
            :style="{ height: '300px' }">
        </OverlayPanel>
        <Dialog 
            v-model:visible="showDiagPeriods"
            @show="focusDiag"
            @hide="hideOP"
            :breakpoints="{ '960px': '85vw', '640px': '90vw' }"
            :style="{ width: '700px' }"
            class="p-fluid"
            >
            <template #header>
                <h5><i class="pi pi-cog">&nbsp;</i>
                    <span class="subtext mt-1">
                        {{ moduleDepartment.key }} - {{ moduleDepartment.label }} ⚡ Vorlauf-Perioden Einstellungen
                    </span>
                </h5>
            </template>
            <div v-if="saveWait" class="flex justify-content-center flex-wrap">
                <ProgressSpinner
                style="width: 50px; height: 50px"
                strokeWidth="4"
                fill="var(--red-600)"
                animationDuration="1s"
                />
            </div>
            <div v-else @keydown.esc="hideOP" @keydown.enter="saveDiag('periods')">
                <loader v-if="dialogLoading" :style="'box'"></loader>
                <TabView v-else :scrollable="true" :activeIndex="diagPeriod">
                    <TabPanel v-for="(element, index) in this.nodeDataPeriods" :key="index">
                        <!-- <Panel :header="returnParameter(element, 'parameter', 'periodName').value + ' - Sollwert'"> -->
                        <template #header>
                            <div class="flex align-items-center gap-2">
                                <span class="white-space-nowrap" :class="this.getDiagDataPeriods(index, 'periodEnable').value ? '' : 'line-through'">{{ index+1 }}: {{ this.getDiagDataPeriods(index, 'periodName').value }}</span>
                            </div>
                        </template>
                        <Panel :header="`${this.getDiagDataPeriods(index, 'periodName').value} - Zeiteinstellungen`" v-if="this.getDiagDataPeriods(index, 'periodEnable').value">
                            <template #icons>
                                <moduleDialogIconHelp icon="fi fi-rr-time-fast" :text="this.getHelpText('periods')"></moduleDialogIconHelp>
                            </template>
                            <div class="formgrid grid p-1">
                                <div class="field col-6">
                                    <TimePeriodInput :id="`periodStart_${index}`" label="🕒Periode Beginn" v-model="this.getDiagDataPeriods(index, 'TimeSetStart').value" v-model:timeMode="this.getDiagDataPeriods(index, 'TimeModeStart').value" v-model:plusMinus="this.getDiagDataPeriods(index, 'TimeSetStart').plusminus" />
                                    <TimeInput :id="`transitionHzgLoHi_${index}`" v-model="this.getDiagDataPeriods(index, 'periodTransition_LoHi').value" :label="this.getDiagDataPeriods(index, 'periodTransition_LoHi').label" :timeMode="1" />
                                </div>
                                <div class="field col-6">
                                    <TimePeriodInput :id="`periodEnd_${index}`" label="🕘Periode Ende" v-model="this.getDiagDataPeriods(index, 'TimeSetEnd').value" v-model:timeMode="this.getDiagDataPeriods(index, 'TimeModeEnd').value" v-model:plusMinus="this.getDiagDataPeriods(index, 'TimeSetEnd').plusminus" />
                                    <TimeInput :id="`transitionHzgHiLo_${index}`" v-model="this.getDiagDataPeriods(index, 'periodTransition_HiLo').value" :label="this.getDiagDataPeriods(index, 'periodTransition_HiLo').label" :timeMode="1" />
                                </div>
                            </div>
                        </Panel>
                        <Panel :header="`${this.getDiagDataPeriods(index, 'periodName').value} - Heizkurve`" class="mt-2" v-if="getDiagDataPeriods(index, 'periodEnable').value && !getModuleValue('CFG.enableMaxRequestMode').value">
                            <template #icons>
                                <i class="fi fi-rr-temperature-low bg-bespin fg-lightYellow p-panel-header-icon text-xl"></i>
                            </template>
                            <div class="formgrid grid p-1">
                                <div class="field col">
                                    <div class="mr-3 ml-3 flex align-items-center justify-content-center">
                                        <i class="fi-rr-temperature-hot fg-lightOrange text-lg" />
                                        <span class="ml-2 text-sm">Außentemperatur</span>
                                    </div>
                                </div>
                                <div class="field col">
                                    <div class="mr-3 ml-3 flex align-items-center justify-content-center">
                                        <i class="fi-rr-oil-temp fg-red text-lg" />
                                        <span class="ml-2 text-sm">Vorlauftemperatur</span>
                                    </div>
                                </div>
                            </div>
                            <div class="formgrid grid p-1">
                                <div class="field col mr-2">
                                    <div class="p-inputgroup">
                                        <span class="p-float-label mr-2">
                                            <InputNumber id="hkAtMin" ref="hkAtMin" :min="-100" :max="100"
                                                v-model="this.getDiagDataPeriods(index, 'hkAtMin').value" autofocus @focus="focusElement"
                                                :minFractionDigits="1" mode="decimal" locale="de-DE" :useGrouping="false"
                                                inputClass="nice-font inputtext-param text-center text-5xl"  />
                                                <label for="hkAtMin" class="mr-2">{{ this.getDiagDataPeriods(index, 'hkAtMin').label }}</label>
                                            <span class="p-inputgroup-addon nice-font text-3xl">{{ this.getDiagDataPeriods(index, 'hkAtMin').unit }}</span>
                                        </span>
                                    </div>
                                </div>
                                <div class="mr-3 ml-3 flex align-items-center justify-content-center">
                                    <i class="fi-rr-arrow-circle-right fg-lightRed text-5xl" />
                                </div>
                                <div class="field col">
                                    <div class="p-inputgroup">
                                        <span class="p-float-label mr-2">
                                            <InputNumber id="hkVlMax" ref="hkVlMax" :min="-100" :max="100"
                                                v-model="this.getDiagDataPeriods(index, 'hkVlMax').value" autofocus @focus="focusElement"
                                                :minFractionDigits="1" mode="decimal" locale="de-DE" :useGrouping="false"
                                                inputClass="nice-font inputtext-param text-center text-5xl"  />
                                                <label for="hkVlMax" class="mr-2">{{ this.getDiagDataPeriods(index, 'hkVlMax').label }}</label>
                                            <span class="p-inputgroup-addon nice-font text-3xl">{{ this.getDiagDataPeriods(index, 'hkVlMax').unit }}</span>
                                        </span>
                                    </div>
                                </div>
                            </div>
                            <div class="formgrid grid p-1">
                                <div class="field col mr-2">
                                    <div class="p-inputgroup">
                                        <span class="p-float-label mr-2">
                                            <InputNumber id="hkAtMax" ref="hkAtMax" :min="-100" :max="150"
                                                v-model="this.getDiagDataPeriods(index, 'hkAtMax').value" autofocus @focus="focusElement"
                                                :minFractionDigits="1" mode="decimal" locale="de-DE" :useGrouping="false"
                                                inputClass="nice-font inputtext-param text-center text-5xl"  />
                                                <label for="hkAtMax" class="mr-2">{{ this.getDiagDataPeriods(index, 'hkAtMax').label }}</label>
                                            <span class="p-inputgroup-addon nice-font text-3xl">{{ this.getDiagDataPeriods(index, 'hkAtMax').unit }}</span>
                                        </span>
                                    </div>
                                </div>
                                <div class="mr-3 ml-3 flex align-items-center justify-content-center">
                                    <i class="fi-rr-arrow-circle-right fg-lightBlue text-5xl" />
                                </div>
                                <div class="field col">
                                    <div class="p-inputgroup">
                                        <span class="p-float-label mr-2">
                                            <InputNumber id="hkVlMin" ref="hkVlMin" :min="-100" :max="150"
                                                v-model="this.getDiagDataPeriods(index, 'hkVlMin').value" autofocus @focus="focusElement"
                                                :minFractionDigits="1" mode="decimal" locale="de-DE" :useGrouping="false"
                                                inputClass="nice-font inputtext-param text-center text-5xl"  />
                                                <label for="hkVlMin" class="mr-2">{{ this.getDiagDataPeriods(index, 'hkVlMin').label }}</label>
                                            <span class="p-inputgroup-addon nice-font text-3xl">{{ this.getDiagDataPeriods(index, 'hkVlMin').unit }}</span>
                                        </span>
                                    </div>
                                </div>
                            </div>
                            <div class="formgrid grid p-1" v-if="this.getDiagDataPeriods(index, 'periodEnable').value">
                                <div class="field col mr-2">
                                    <div class="p-inputgroup">
                                        <span class="p-float-label mr-2">
                                            <InputNumber id="vlMinTemp" ref="vlMinTemp" :min="-100" :max="150"
                                                v-model="this.getDiagDataPeriods(index, 'vlMinTemp').value" autofocus @focus="focusElement"
                                                :minFractionDigits="1" mode="decimal" locale="de-DE" :useGrouping="false"
                                                inputClass="nice-font inputtext-param text-center text-xl"  />
                                                <label for="vlMinTemp" class="mr-2">{{ this.getDiagDataPeriods(index, 'vlMinTemp').label }}</label>
                                            <span class="p-inputgroup-addon nice-font text-xl">{{ this.getDiagDataPeriods(index, 'vlMinTemp').unit }}</span>
                                        </span>
                                    </div>
                                </div>
                                <div class="field col">
                                    <div class="p-inputgroup">
                                        <span class="p-float-label mr-2">
                                            <InputNumber id="vlMaxTemp" ref="vlMaxTemp" :min="-100" :max="150"
                                                v-model="this.getDiagDataPeriods(index, 'vlMaxTemp').value" autofocus @focus="focusElement"
                                                :minFractionDigits="1" mode="decimal" locale="de-DE" :useGrouping="false"
                                                inputClass="nice-font inputtext-param text-center text-xl"  />
                                                <label for="vlMaxTemp" class="mr-2">{{ this.getDiagDataPeriods(index, 'vlMaxTemp').label }}</label>
                                            <span class="p-inputgroup-addon nice-font text-xl">{{ this.getDiagDataPeriods(index, 'vlMaxTemp').unit }}</span>
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </Panel>
                        <Panel :header="`${this.getDiagDataPeriods(index, 'periodName').value} - Frostschutz`" class="mt-3" v-if="this.getDiagDataPeriods(index, 'periodEnable').value">
                            <template #icons>
                                <i class="fi fi-rr-temperature-low bg-bespin fg-lightYellow p-panel-header-icon text-xl"></i>
                            </template>
                            <div class="formgrid grid p-1">
                                <div class="field col mr-2">
                                    <div class="p-inputgroup">
                                        <span class="p-float-label mr-2">
                                            <InputNumber id="pumpFrostStart" ref="pumpFrostStart" :min="-100" :max="150"
                                                v-model="this.getDiagDataPeriods(index, 'pumpFrostStart').value" autofocus @focus="focusElement"
                                                :minFractionDigits="1" mode="decimal" locale="de-DE" :useGrouping="false"
                                                inputClass="nice-font inputtext-param text-center text-xl"  />
                                                <label for="pumpFrostStart" class="mr-2">{{ this.getDiagDataPeriods(index, 'pumpFrostStart').label }}</label>
                                            <span class="p-inputgroup-addon nice-font text-xl">{{ this.getDiagDataPeriods(index, 'pumpFrostStart').unit }}</span>
                                        </span>
                                    </div>
                                </div>
                                <div class="field col">
                                    <div class="p-inputgroup">
                                        <span class="p-float-label mr-2">
                                            <InputNumber id="pumpFrostValue" ref="pumpFrostValue" :min="-100" :max="150"
                                                v-model="this.getDiagDataPeriods(index, 'pumpFrostValue').value" autofocus @focus="focusElement"
                                                :minFractionDigits="1" mode="decimal" locale="de-DE" :useGrouping="false"
                                                inputClass="nice-font inputtext-param text-center text-xl"  />
                                                <label for="pumpFrostValue" class="mr-2">{{ this.getDiagDataPeriods(index, 'pumpFrostValue').label }}</label>
                                            <span class="p-inputgroup-addon nice-font text-xl">{{ this.getDiagDataPeriods(index, 'pumpFrostValue').unit }}</span>
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </Panel>
                        <Panel :header="`${this.getDiagDataPeriods(index, 'periodName').value} - Rücklaufregelung`" class="mt-3" v-if="this.getDiagDataPeriods(index, 'periodEnable').value">
                            <template #icons>
                                <i class="fi fi-rr-temperature-low bg-bespin fg-lightYellow p-panel-header-icon text-xl"></i>
                            </template>
                            <div class="formgrid grid p-1">
                                <div class="field col mr-2">
                                    <div class="p-inputgroup">
                                        <span class="p-float-label mr-2">
                                            <InputNumber id="rlMinTemp" ref="rlMinTemp" :min="-100" :max="150"
                                                v-model="this.getDiagDataPeriods(index, 'rlMinTemp').value" autofocus @focus="focusElement"
                                                :minFractionDigits="1" mode="decimal" locale="de-DE" :useGrouping="false"
                                                inputClass="nice-font inputtext-param text-center text-xl"  />
                                                <label for="rlMinTemp" class="mr-2">{{ this.getDiagDataPeriods(index, 'rlMinTemp').label }}</label>
                                            <span class="p-inputgroup-addon nice-font text-xl">{{ this.getDiagDataPeriods(index, 'rlMinTemp').unit }}</span>
                                        </span>
                                    </div>
                                </div>
                                <div class="field col">
                                    <div class="p-inputgroup">
                                        <span class="p-float-label mr-2">
                                            <InputNumber id="rlMaxTemp" ref="rlMaxTemp" :min="-100" :max="150"
                                                v-model="this.getDiagDataPeriods(index, 'rlMaxTemp').value" autofocus @focus="focusElement"
                                                :minFractionDigits="1" mode="decimal" locale="de-DE" :useGrouping="false"
                                                inputClass="nice-font inputtext-param text-center text-xl"  />
                                                <label for="rlMaxTemp" class="mr-2">{{ this.getDiagDataPeriods(index, 'rlMaxTemp').label }}</label>
                                            <span class="p-inputgroup-addon nice-font text-xl">{{ this.getDiagDataPeriods(index, 'rlMaxTemp').unit }}</span>
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </Panel>
                        <div class="formgrid grid p-1">
                            <div class="field col">
                                <div class="flex justify-content-center mt-2">
                                    <Button label="Periodenbezeichnung ändern" @click="toogleNameDiag(this.getDiagDataPeriods(index, 'periodName'))" />
                                </div>
                            </div>
                        </div>
                        
                    </TabPanel>
                </TabView>
            </div>
            <template #footer>
                <widgetDialogFooter :widgetName="`${this.$options.name}_periods`" :department="moduleDepartment.key" :exchange="true" format="json" :saveCheck="periodCheck"
                    @diagAbort="diagTogglePeriods"
                    @diagSave="saveDiag('periods')"
                    @import="($value) => {this.nodeDataPeriods = $value}"
                    :exportObject="this.nodeDataPeriods"
                ></widgetDialogFooter>
            </template>
        </Dialog>
        <OverlayPanel ref="misc" appendTo="body" @show="focusElement" :dismissable="false">
        </OverlayPanel>
        <Dialog
            v-model:visible="showDiagMisc"
            @show="focusElement"
            :breakpoints="{ '960px': '85vw', '640px': '90vw' }"
            :style="{ width: '700px' }"
        >
            <template #header>
                <h5><i class="pi pi-cog">&nbsp;</i><span class="subtext mt-1">{{ moduleDepartment.key }} {{ moduleDepartment.label }} ⚡ Allgemeine Einstellungen</span></h5>
            </template>
            <div v-if="saveWait" class="flex justify-content-center flex-wrap">
                <ProgressSpinner
                style="width: 50px; height: 50px"
                strokeWidth="4"
                fill="var(--red-600)"
                animationDuration="1s"
                />
            </div>
            <div v-else @keydown.esc="hideOP" @keydown.enter="saveDiag('misc')">
                <loader v-if="dialogLoading" :style="'box'"></loader>
                <TabView :scrollable="true">
                    <TabPanel header="Heizungsregler">
                        <Panel header="Temperatureinstellungen">
                            <template #icons>
                                <i class="fi fi-rr-temperature-low bg-bespin fg-lightYellow p-panel-header-icon text-xl"></i>
                            </template>
                            <div class="formgrid grid p-1">
                                <div class="field col">
                                    <span class="p-float-label mr-2">
                                        <InputNumber id="vlPitchTemp" ref="vlPitchTemp" :min="-100" :max="100"
                                            v-model="getDiagDataCfg('vlPitchTemp').value" mode="decimal"
                                            :suffix="` ${getDiagDataCfg('vlPitchTemp').unit}`"
                                            :minFractionDigits="1" :useGrouping="false" locale="de-DE"
                                            @focus="focusElement" class="p-inputtext-lg w-full" />
                                        <label for="vlPitchTemp" class="mr-2">{{ getDiagDataCfg('vlPitchTemp').label }}</label>
                                    </span>
                                </div>
                                <div class="field col">
                                    <span class="p-float-label mr-2">
                                        <InputNumber id="controllOffHyst" ref="controllOffHyst" :min="-50" :max="100"
                                            v-model="getDiagDataCfg('controllOffHyst').value" mode="decimal"
                                            :suffix="` ${getDiagDataCfg('controllOffHyst').unit}`"
                                            :minFractionDigits="1" :useGrouping="false" locale="de-DE"
                                            @focus="focusElement" class="p-inputtext-lg w-full" />
                                        <label for="controllOffHyst" class="mr-2">{{ getDiagDataCfg('controllOffHyst').label }}</label>
                                    </span>
                                </div>
                            </div>
                        </Panel>
                        <Panel header="Pumpen-Einstellungen" class="mt-2">
                            <template #icons>
                                <i class="fi fi-rr-clock bg-bespin fg-lightYellow p-panel-header-icon text-xl"></i>
                            </template>
                            <div class="formgrid grid p-1">
                                <div class="field col">
                                    <TimeInput :id="`pumpOffDelay`" v-model="this.getDiagDataCfg('pumpOffDelay').value" :label="this.getDiagDataCfg('pumpOffDelay').label" :timeMode="-1" />
                                </div>
                                <div class="field col">
                                    <span class="p-float-label mr-2">
                                        <InputMask id="pumpAutoStart" ref="pumpAutoStart" mask="999:99:99"
                                            placeholder="" slotChar="hhh:mm:ss"
                                            v-model="this.getDiagDataCfg('pumpAutoStart').value"
                                            @focus="focusElement" class="p-inputtext-lg w-full" />
                                        <label for="pumpAutoStart" class="mr-2">{{ getDiagDataCfg('pumpAutoStart').label }}</label>
                                    </span>
                                </div>
                            </div>
                            <div class="formgrid grid p-1">
                                <div class="field col">
                                    <TimeInput :id="`pumpFrostIntOn`" v-model="this.getDiagDataCfg('pumpFrostIntOn').value" :label="this.getDiagDataCfg('pumpFrostIntOn').label" :timeMode="-1" />
                                </div>
                                <div class="field col">
                                    <TimeInput :id="`pumpFrostIntOff`" v-model="this.getDiagDataCfg('pumpFrostIntOff').value" :label="this.getDiagDataCfg('pumpFrostIntOff').label" :timeMode="-1" />
                                </div>
                            </div>
                            <div class="formgrid grid p-1">
                                <div class="field col">
                                    <div class="field col flex justify-content-center">
                                        <div class="flex align-items-center mt-3">
                                            <InputSwitch v-model="this.getDiagDataCfg('useStage2').value" /><span class="ml-2">{{ this.getDiagDataCfg('useStage2').label }}</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="formgrid grid p-1" v-if="this.getDiagDataCfg('useStage2').value">
                                <div class="field col">
                                    <span class="p-float-label mr-2">
                                        <InputNumber id="pumpStage2" ref="pumpStage2" :min="-100" :max="100"
                                            v-model="getDiagDataCfg('pumpStage2').value" mode="decimal"
                                            :suffix="` ${getDiagDataCfg('pumpStage2').unit}`"
                                            :minFractionDigits="1" :useGrouping="false" locale="de-DE"
                                            @focus="focusElement" class="p-inputtext-lg w-full" />
                                        <label for="pumpStage2" class="mr-2">{{ getDiagDataCfg('pumpStage2').label }}</label>
                                    </span>
                                </div>
                                <div class="field col">
                                    <span class="p-float-label mr-2">
                                        <InputNumber id="pumpStage2Hyst" ref="pumpStage2Hyst" :min="-50" :max="100"
                                            v-model="getDiagDataCfg('pumpStage2Hyst').value" mode="decimal"
                                            :suffix="` ${getDiagDataCfg('pumpStage2Hyst').unit}`"
                                            :minFractionDigits="1" :useGrouping="false" locale="de-DE"
                                            @focus="focusElement" class="p-inputtext-lg w-full" />
                                        <label for="pumpStage2Hyst" class="mr-2">{{ getDiagDataCfg('pumpStage2Hyst').label }}</label>
                                    </span>
                                </div>
                            </div>
                        </Panel>
                        <Panel header="Mischventil-Einstellungen" class="mt-2">
                            <template #icons>
                                <i class="fi fi-rr-heat bg-bespin fg-lightYellow p-panel-header-icon text-xl"></i>
                            </template>
                            <div class="formgrid grid p-1">
                                <div class="field col">
                                    <TimeInput :id="`runtime`" v-model="this.getDiagDataCfg('runtime').value" :label="this.getDiagDataCfg('runtime').label" :timeMode="-1" />
                                </div>
                                <div class="field col">
                                    <span class="p-float-label mr-2">
                                        <InputNumber id="valveDeadzone" ref="valveDeadzone" :min="0" :max="100"
                                            v-model="getDiagDataCfg('valveDeadzone').value" mode="decimal"
                                            :suffix="` ${getDiagDataCfg('valveDeadzone').unit}`"
                                            :minFractionDigits="1" :useGrouping="false" locale="de-DE"
                                            @focus="focusElement" class="p-inputtext-lg w-full" />
                                        <label for="valveDeadzone" class="mr-2">{{ getDiagDataCfg('valveDeadzone').label }}</label>
                                    </span>
                                </div>
                            </div>
                            <div class="formgrid grid p-1">
                                <div class="field col">
                                    <span class="p-float-label mr-2">
                                        <InputNumber id="pFactor" ref="pFactor" :min="0.1" :max="10000"
                                            v-model="getDiagDataCfg('pFactor').value" mode="decimal"
                                            :suffix="` ${getDiagDataCfg('pFactor').unit}`"
                                            :minFractionDigits="1" :useGrouping="false" locale="de-DE"
                                            @focus="focusElement" class="p-inputtext-lg w-full" />
                                        <label for="pFactor" class="mr-2">{{ getDiagDataCfg('pFactor').label }}</label>
                                    </span>
                                </div>
                                <div class="field col">
                                    <span class="p-float-label mr-2">
                                        <InputNumber id="iFactor" ref="iFactor" :min="0" :max="10000"
                                            v-model="getDiagDataCfg('iFactor').value" mode="decimal"
                                            :suffix="` ${getDiagDataCfg('iFactor').unit}`"
                                            :minFractionDigits="3" :useGrouping="false" locale="de-DE"
                                            @focus="focusElement" class="p-inputtext-lg w-full" />
                                        <label for="iFactor" class="mr-2">{{ getDiagDataCfg('iFactor').label }}</label>
                                    </span>
                                </div>
                            </div>
                            <div class="formgrid grid p-1 mt-2">
                                <div class="field col">
                                    <span class="p-float-label mr-2">
                                        <InputNumber id="valveRuntimeFactor" ref="valveRuntimeFactor" :min="0" :max="1000"
                                            v-model="getDiagDataCfg('valveRuntimeFactor').value" mode="decimal"
                                            :suffix="` ${getDiagDataCfg('valveRuntimeFactor').unit}`"
                                            :minFractionDigits="3" :useGrouping="false" locale="de-DE"
                                            @focus="focusElement" class="p-inputtext-lg w-full" />
                                        <label for="valveRuntimeFactor" class="mr-2">{{ getDiagDataCfg('valveRuntimeFactor').label }}</label>
                                    </span>
                                </div>
                            </div>
                            <div class="formgrid grid p-1">
                                <div class="field col">
                                    <span class="p-float-label mr-2">
                                        <InputNumber id="controlPauseTime" ref="controlPauseTime" :min="0" :max="100000"
                                            v-model="getDiagDataCfg('controlPauseTime').value" mode="decimal"
                                            :suffix="` ${getDiagDataCfg('controlPauseTime').unit}`"
                                            :minFractionDigits="0" :useGrouping="false" locale="de-DE"
                                            @focus="focusElement" class="p-inputtext-lg w-full" />
                                        <label for="controlPauseTime" class="mr-2">{{ getDiagDataCfg('controlPauseTime').label }}</label>
                                    </span>
                                </div>
                                <div class="field col">
                                    <span class="p-float-label mr-2">
                                        <InputNumber id="deadBand" ref="deadBand" :min="0" :max="100"
                                            v-model="getDiagDataCfg('deadBand').value" mode="decimal"
                                            :suffix="` ${getDiagDataCfg('deadBand').unit}`"
                                            :minFractionDigits="1" :useGrouping="false" locale="de-DE"
                                            @focus="focusElement" class="p-inputtext-lg w-full" />
                                        <label for="deadBand" class="mr-2">{{ getDiagDataCfg('deadBand').label }}</label>
                                    </span>
                                </div>
                            </div>
                            <div class="formgrid grid p-1">
                                <div class="field col">
                                    <span class="p-float-label mr-2">
                                        <InputNumber id="calcFilterTime" ref="calcFilterTime" :min="0" :max="100000"
                                            v-model="getDiagDataCfg('calcFilterTime').value" mode="decimal"
                                            :suffix="` ${getDiagDataCfg('calcFilterTime').unit}`"
                                            :minFractionDigits="0" :useGrouping="false" locale="de-DE"
                                            @focus="focusElement" class="p-inputtext-lg w-full" />
                                        <label for="calcFilterTime" class="mr-2">{{ getDiagDataCfg('calcFilterTime').label }}</label>
                                    </span>
                                </div>
                                <div class="field col">
                                    <span class="p-float-label mr-2">
                                        <InputNumber id="calcFilterValue" ref="calcFilterValue" :min="0" :max="100"
                                            v-model="getDiagDataCfg('calcFilterValue').value" mode="decimal"
                                            :suffix="` ${getDiagDataCfg('calcFilterValue').unit}`"
                                            :minFractionDigits="1" :useGrouping="false" locale="de-DE"
                                            @focus="focusElement" class="p-inputtext-lg w-full" />
                                        <label for="calcFilterValue" class="mr-2">{{ getDiagDataCfg('calcFilterValue').label }}</label>
                                    </span>
                                </div>
                            </div>
                            <div class="formgrid grid p-1 mt-2">
                                <div class="field col">
                                    <TimeInput :id="`setpointDelay`" v-model="this.getDiagDataCfg('setpointDelay').value" :label="this.getDiagDataCfg('setpointDelay').label" :timeMode="-1" />
                                </div>
                                <div class="field col">
                                    <TimeInput :id="`ctrlDelay`" v-model="this.getDiagDataCfg('ctrlDelay').value" :label="this.getDiagDataCfg('ctrlDelay').label" :timeMode="-1" />
                                </div>
                            </div>
                            <div class="formgrid grid p-1">
                                <div class="field col">
                                    <div class="field col flex justify-content-center">
                                        <div class="flex align-items-center mt-3">
                                            <InputSwitch v-model="this.getDiagDataCfg('iFactorPosDiff').value" /><span class="ml-2">{{ this.getDiagDataCfg('iFactorPosDiff').label }}</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </Panel>
                        <Panel header="Manueller Betrieb" class="mt-2">
                            <div class="formgrid grid p-1">
                                <div class="field col">
                                    <div class="field col flex justify-content-center">
                                        <div class="flex align-items-center mt-3">
                                            <InputSwitch v-model="this.getDiagDataCfg('enableManual').value" /><span class="ml-2">{{ this.getDiagDataCfg('enableManual').label }}</span>
                                        </div>
                                    </div>
                                </div>
                                <div class="field col">
                                    <div class="field col flex justify-content-center">
                                        <div class="flex align-items-center mt-3">
                                            <InputSwitch v-model="this.getDiagDataCfg('valveManual').value" /><span class="ml-2">{{ this.getDiagDataCfg('valveManual').label }}</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="formgrid grid p-1">
                                <div class="field col">
                                </div>
                                <div class="field col" v-if="this.getDiagDataCfg('valveManual').value">
                                    <span class="p-float-label mr-2">
                                        <InputNumber id="valveManualSet" ref="valveManualSet" :min="0" :max="100"
                                            v-model="getDiagDataCfg('valveManualSet').value" mode="decimal"
                                            :suffix="` ${getDiagDataCfg('valveManualSet').unit}`"
                                            :minFractionDigits="1" :useGrouping="false" locale="de-DE"
                                            @focus="focusElement" class="p-inputtext-lg w-full" />
                                        <label for="valveManualSet" class="mr-2">{{ getDiagDataCfg('valveManualSet').label }}</label>
                                    </span>
                                </div>
                            </div>
                        </Panel>
                        <Panel header="Sollwert Vorlauftemperatur" class="mt-2" v-if="isMaster">
                            <div class="formgrid grid p-1">
                                <div class="field col">
                                    <div class="field col flex justify-content-center">
                                        <div class="flex align-items-center mt-3">
                                            <InputSwitch v-model="this.getDiagDataCfg('enableMaxRequestMode').value" /><span class="ml-2">{{ this.getDiagDataCfg('enableMaxRequestMode').label }}</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </Panel>
                        <Panel header="Externe Anforderung" class="mt-2" v-if="isMaster">
                            <div class="formgrid grid p-1">
                                <div class="field col">
                                    <div class="field col flex justify-content-center">
                                        <div class="flex align-items-center mt-3">
                                            <InputSwitch v-model="this.getDiagDataCfg('enableExternRequest').value" /><span class="ml-2">{{ this.getDiagDataCfg('enableExternRequest').label }}</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </Panel> 
                    </TabPanel>
                    <TabPanel header="Rücklaufsteuerung" v-if="isMaster">
                        <Panel header="Rücklaufsteuerung Einstellung">
                            <div class="formgrid grid p-1">
                                <div class="field col">
                                    <div class="field col flex justify-content-center">
                                        <div class="flex align-items-center mt-3">
                                            <InputSwitch v-model="this.getDiagDataCfg('enableRlControl').value" /><span class="ml-2">{{ this.getDiagDataCfg('enableRlControl').label }}</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </Panel> 
                        <Panel header="Mischventil-Einstellungen" class="mt-2" v-if="this.getDiagDataCfg('enableRlControl').value">
                            <template #icons>
                                <i class="fi fi-rr-heat bg-bespin fg-lightYellow p-panel-header-icon text-xl"></i>
                            </template>
                            <div class="formgrid grid p-1">
                                <div class="field col">
                                    <TimeInput :id="`runtimeRl`" v-model="this.getDiagDataCfg('runtimeRl').value" :label="this.getDiagDataCfg('runtimeRl').label" :timeMode="-1" />
                                </div>
                                <div class="field col">
                                    <span class="p-float-label mr-2">
                                        <InputNumber id="valveDeadzoneRl" ref="valveDeadzoneRl" :min="0" :max="100"
                                            v-model="getDiagDataCfg('valveDeadzoneRl').value" mode="decimal"
                                            :suffix="` ${getDiagDataCfg('valveDeadzoneRl').unit}`"
                                            :minFractionDigits="1" :useGrouping="false" locale="de-DE"
                                            @focus="focusElement" class="p-inputtext-lg w-full" />
                                        <label for="valveDeadzoneRl" class="mr-2">{{ getDiagDataCfg('valveDeadzoneRl').label }}</label>
                                    </span>
                                </div>
                            </div>
                            <div class="formgrid grid p-1">
                                <div class="field col">
                                    <span class="p-float-label mr-2">
                                        <InputNumber id="pFactorRl" ref="pFactorRl" :min="0.1" :max="10000"
                                            v-model="getDiagDataCfg('pFactorRl').value" mode="decimal"
                                            :suffix="` ${getDiagDataCfg('pFactorRl').unit}`"
                                            :minFractionDigits="1" :useGrouping="false" locale="de-DE"
                                            @focus="focusElement" class="p-inputtext-lg w-full" />
                                        <label for="pFactorRl" class="mr-2">{{ getDiagDataCfg('pFactorRl').label }}</label>
                                    </span>
                                </div>
                                <div class="field col">
                                    <span class="p-float-label mr-2">
                                        <InputNumber id="iFactorRl" ref="iFactorRl" :min="0" :max="10000"
                                            v-model="getDiagDataCfg('iFactorRl').value" mode="decimal"
                                            :suffix="` ${getDiagDataCfg('iFactorRl').unit}`"
                                            :minFractionDigits="3" :useGrouping="false" locale="de-DE"
                                            @focus="focusElement" class="p-inputtext-lg w-full" />
                                        <label for="iFactorRl" class="mr-2">{{ getDiagDataCfg('iFactorRl').label }}</label>
                                    </span>
                                </div>
                            </div>
                            <div class="formgrid grid p-1 mt-2">
                                <div class="field col">
                                    <span class="p-float-label mr-2">
                                        <InputNumber id="valveRuntimeFactorRl" ref="valveRuntimeFactorRl" :min="0" :max="1000"
                                            v-model="getDiagDataCfg('valveRuntimeFactorRl').value" mode="decimal"
                                            :suffix="` ${getDiagDataCfg('valveRuntimeFactorRl').unit}`"
                                            :minFractionDigits="3" :useGrouping="false" locale="de-DE"
                                            @focus="focusElement" class="p-inputtext-lg w-full" />
                                        <label for="valveRuntimeFactorRl" class="mr-2">{{ getDiagDataCfg('valveRuntimeFactorRl').label }}</label>
                                    </span>
                                </div>
                            </div>
                            <div class="formgrid grid p-1">
                                <div class="field col">
                                    <span class="p-float-label mr-2">
                                        <InputNumber id="controlPauseTimeRl" ref="controlPauseTimeRl" :min="0" :max="100000"
                                            v-model="getDiagDataCfg('controlPauseTimeRl').value" mode="decimal"
                                            :suffix="` ${getDiagDataCfg('controlPauseTimeRl').unit}`"
                                            :minFractionDigits="0" :useGrouping="false" locale="de-DE"
                                            @focus="focusElement" class="p-inputtext-lg w-full" />
                                        <label for="controlPauseTimeRl" class="mr-2">{{ getDiagDataCfg('controlPauseTimeRl').label }}</label>
                                    </span>
                                </div>
                                <div class="field col">
                                    <span class="p-float-label mr-2">
                                        <InputNumber id="deadBandRl" ref="deadBandRl" :min="0" :max="100"
                                            v-model="getDiagDataCfg('deadBandRl').value" mode="decimal"
                                            :suffix="` ${getDiagDataCfg('deadBandRl').unit}`"
                                            :minFractionDigits="1" :useGrouping="false" locale="de-DE"
                                            @focus="focusElement" class="p-inputtext-lg w-full" />
                                        <label for="deadBandRl" class="mr-2">{{ getDiagDataCfg('deadBandRl').label }}</label>
                                    </span>
                                </div>
                            </div>
                            <div class="formgrid grid p-1 mt-2">
                                <div class="field col">
                                    <TimeInput :id="`setpointDelayRl`" v-model="this.getDiagDataCfg('setpointDelayRl').value" :label="this.getDiagDataCfg('setpointDelayRl').label" :timeMode="-1" />
                                </div>
                            </div>
                            <div class="formgrid grid p-1">
                                <div class="field col">
                                    <div class="field col flex justify-content-center">
                                        <div class="flex align-items-center mt-3">
                                            <InputSwitch v-model="this.getDiagDataCfg('iFactorPosDiffRl').value" /><span class="ml-2">{{ this.getDiagDataCfg('iFactorPosDiffRl').label }}</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </Panel>
                        <Panel header="Manueller Betrieb" class="mt-2">
                            <div class="formgrid grid p-1">
                                <div class="field col">
                                    <div class="field col flex justify-content-center">
                                        <div class="flex align-items-center mt-3">
                                            <InputSwitch v-model="this.getDiagDataCfg('valveManualRl').value" /><span class="ml-2">{{ this.getDiagDataCfg('valveManualRl').label }}</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="formgrid grid p-1">
                                <div class="field col">
                                </div>
                                <div class="field col" v-if="this.getDiagDataCfg('valveManualRl').value">
                                    <span class="p-float-label mr-2">
                                        <InputNumber id="valveManualSetRl" ref="valveManualSetRl" :min="0" :max="100"
                                            v-model="getDiagDataCfg('valveManualSetRl').value" mode="decimal"
                                            :suffix="` ${getDiagDataCfg('valveManualSetRl').unit}`"
                                            :minFractionDigits="1" :useGrouping="false" locale="de-DE"
                                            @focus="focusElement" class="p-inputtext-lg w-full" />
                                        <label for="valveManualSetRl" class="mr-2">{{ getDiagDataCfg('valveManualSetRl').label }}</label>
                                    </span>
                                </div>
                            </div>
                        </Panel> 
                    </TabPanel>
                    <TabPanel header="Alarme Vorlauf">
                        <Panel header="Alarmeinstellungen Minimum-Temperatur Vorlauf">
                            <template #icons>
                                <i class="fi fi-rr-temperature-low bg-bespin fg-lightYellow p-panel-header-icon text-xl"></i>
                            </template>
                            <div class="formgrid grid p-1">
                                <div class="field col">
                                    <span class="p-float-label mr-2">
                                        <InputNumber id="alarmVlMin" ref="alarmVlMin" :min="-50" :max="150"
                                            v-model="getDiagDataCfg('alarmVlMin').value" mode="decimal"
                                            :suffix="` ${getDiagDataCfg('alarmVlMin').unit}`"
                                            :minFractionDigits="1" :useGrouping="false" locale="de-DE"
                                            @focus="focusElement" class="p-inputtext-lg w-full" />
                                        <label for="alarmVlMin" class="mr-2">{{ getDiagDataCfg('alarmVlMin').label }}</label>
                                    </span>
                                </div>
                                <div class="field col">
                                    <div class="flex justify-content-center">
                                        <SelectButton v-model="getDiagDataCfg('alarmVlMinPrior').value" :options="this.$store.getters.getAlarmPrior" optionLabel="name" optionValue="value" dataKey="value" aria-labelledby="name">
                                            <template #option="slotProps">
                                                <span class="flex justify-content-center mx-auto" v-tooltip="slotProps.option.name"><i :class="slotProps.option.icon" class="text-xl icon-inline"></i></span>
                                            </template>
                                        </SelectButton>
                                    </div>
                                </div>
                            </div>
                            <div class="formgrid grid p-1">
                                <div class="field col">
                                    <span class="p-float-label mr-2">
                                        <InputNumber id="alarmVlMinDiff" ref="alarmVlMinDiff" :min="-150" :max="150"
                                            v-model="getDiagDataCfg('alarmVlMinDiff').value" mode="decimal"
                                            :suffix="` ${getDiagDataCfg('alarmVlMinDiff').unit}`"
                                            :minFractionDigits="1" :useGrouping="false" locale="de-DE"
                                            @focus="focusElement" class="p-inputtext-lg w-full" />
                                        <label for="alarmVlMinDiff" class="mr-2">{{ getDiagDataCfg('alarmVlMinDiff').label }}</label>
                                    </span>
                                </div>
                                <div class="field col">
                                    <TimeInput :id="`alarmVlMinDelay`" v-model="this.getDiagDataCfg('alarmVlMinDelay').value" :label="this.getDiagDataCfg('alarmVlMinDelay').label" :timeMode="-1" />
                                </div>
                            </div>
                        </Panel>
                        <Panel header="Alarmeinstellungen Maximum-Temperatur Vorlauf" class="mt-2">
                            <template #icons>
                                <i class="fi fi-rr-temperature-high bg-bespin fg-lightYellow p-panel-header-icon text-xl"></i>
                            </template>
                            <div class="formgrid grid p-1">
                                <div class="field col">
                                    <span class="p-float-label mr-2">
                                        <InputNumber id="alarmVlMax" ref="alarmVlMax" :min="-50" :max="150"
                                            v-model="getDiagDataCfg('alarmVlMax').value" mode="decimal"
                                            :suffix="` ${getDiagDataCfg('alarmVlMax').unit}`"
                                            :minFractionDigits="1" :useGrouping="false" locale="de-DE"
                                            @focus="focusElement" class="p-inputtext-lg w-full" />
                                        <label for="alarmVlMax" class="mr-2">{{ getDiagDataCfg('alarmVlMax').label }}</label>
                                    </span>
                                </div>
                                <div class="field col">
                                    <div class="flex justify-content-center">
                                        <SelectButton v-model="getDiagDataCfg('alarmVlMaxPrior').value" :options="this.$store.getters.getAlarmPrior" optionLabel="name" optionValue="value" dataKey="value" aria-labelledby="name">
                                            <template #option="slotProps">
                                                <span class="flex justify-content-center mx-auto" v-tooltip="slotProps.option.name"><i :class="slotProps.option.icon" class="text-xl icon-inline"></i></span>
                                            </template>
                                        </SelectButton>
                                    </div>
                                </div>
                            </div>
                            <div class="formgrid grid p-1">
                                <div class="field col">
                                    <span class="p-float-label mr-2">
                                        <InputNumber id="alarmVlMaxDiff" ref="alarmVlMaxDiff" :min="-150" :max="150"
                                            v-model="getDiagDataCfg('alarmVlMaxDiff').value" mode="decimal"
                                            :suffix="` ${getDiagDataCfg('alarmVlMaxDiff').unit}`"
                                            :minFractionDigits="1" :useGrouping="false" locale="de-DE"
                                            @focus="focusElement" class="p-inputtext-lg w-full" />
                                        <label for="alarmVlMaxDiff" class="mr-2">{{ getDiagDataCfg('alarmVlMaxDiff').label }}</label>
                                    </span>
                                </div>
                                <div class="field col">
                                    <TimeInput :id="`alarmVlMaxDelay`" v-model="this.getDiagDataCfg('alarmVlMaxDelay').value" :label="this.getDiagDataCfg('alarmVlMaxDelay').label" :timeMode="-1" />
                                </div>
                            </div>
                        </Panel>
                        <Panel header="Alarmeinstellungen Differenz-Temperatur Vorlauf" class="mt-2">
                            <template #icons>
                                <i class="fi fi-rr-temperature-high bg-bespin fg-lightYellow p-panel-header-icon text-xl"></i>
                            </template>
                            <div class="formgrid grid p-1">
                                <div class="field col">
                                    <span class="p-float-label mr-2">
                                        <InputNumber id="alarmVlDiff" ref="alarmVlDiff" :min="-50" :max="150"
                                            v-model="getDiagDataCfg('alarmVlDiff').value" mode="decimal"
                                            :suffix="` ${getDiagDataCfg('alarmVlDiff').unit}`"
                                            :minFractionDigits="1" :useGrouping="false" locale="de-DE"
                                            @focus="focusElement" class="p-inputtext-lg w-full" />
                                        <label for="alarmVlDiff" class="mr-2">{{ getDiagDataCfg('alarmVlDiff').label }}</label>
                                    </span>
                                </div>
                                <div class="field col">
                                    <div class="flex justify-content-center">
                                        <SelectButton v-model="getDiagDataCfg('alarmVlDiffPrior').value" :options="this.$store.getters.getAlarmPrior" optionLabel="name" optionValue="value" dataKey="value" aria-labelledby="name">
                                            <template #option="slotProps">
                                                <span class="flex justify-content-center mx-auto" v-tooltip="slotProps.option.name"><i :class="slotProps.option.icon" class="text-xl icon-inline"></i></span>
                                            </template>
                                        </SelectButton>
                                    </div>
                                </div>
                            </div>
                            <div class="formgrid grid p-1">
                                <div class="field col">
                                    <span class="p-float-label mr-2">
                                        <InputNumber id="alarmVlDiffDiff" ref="alarmVlDiffDiff" :min="-150" :max="150"
                                            v-model="getDiagDataCfg('alarmVlDiffDiff').value" mode="decimal"
                                            :suffix="` ${getDiagDataCfg('alarmVlDiffDiff').unit}`"
                                            :minFractionDigits="1" :useGrouping="false" locale="de-DE"
                                            @focus="focusElement" class="p-inputtext-lg w-full" />
                                        <label for="alarmVlDiffDiff" class="mr-2">{{ getDiagDataCfg('alarmVlDiffDiff').label }}</label>
                                    </span>
                                </div>
                                <div class="field col">
                                    <TimeInput :id="`alarmVlDiffDelay`" v-model="this.getDiagDataCfg('alarmVlDiffDelay').value" :label="this.getDiagDataCfg('alarmVlDiffDelay').label" :timeMode="-1" />
                                </div>
                            </div>
                        </Panel>
                        <Panel header="Alarmeinstellungen Sensoralarm Vorlauf" class="mt-3" v-if="isMaster">
                            <template #icons>
                                <i class="fi fi-rr-temperature-low bg-bespin fg-lightYellow p-panel-header-icon text-xl"></i>
                            </template>
                            <div class="formgrid grid p-1">
                                <div class="field col">
                                    <span class="p-float-label mr-2">
                                        <InputNumber id="alarmVlSensorDiff" ref="alarmVlSensorDiff" :min="-150" :max="150"
                                            v-model="getDiagDataCfg('alarmVlSensorDiff').value" mode="decimal"
                                            :suffix="` ${getDiagDataCfg('alarmVlSensorDiff').unit}`"
                                            :minFractionDigits="1" :useGrouping="false" locale="de-DE"
                                            @focus="focusElement" class="p-inputtext-lg w-full" />
                                        <label for="alarmVlSensorDiff" class="mr-2">{{ getDiagDataCfg('alarmVlSensorDiff').label }}</label>
                                    </span>
                                </div>
                                <div class="field col">
                                    <TimeInput :id="`alarmVlSensorDelay`" v-model="this.getDiagDataCfg('alarmVlSensorDelay').value" :label="this.getDiagDataCfg('alarmVlSensorDelay').label" :timeMode="-1" />
                                </div>
                            </div>
                            <div class="formgrid grid p-1">
                                <div class="field col">
                                    <div class="flex justify-content-center">
                                        <SelectButton v-model="getDiagDataCfg('alarmVlSensorPrior').value" :options="this.$store.getters.getAlarmPrior" optionLabel="name" optionValue="value" dataKey="value" aria-labelledby="name">
                                            <template #option="slotProps">
                                                <span class="flex justify-content-center mx-auto" v-tooltip="slotProps.option.name"><i :class="slotProps.option.icon" class="text-xl icon-inline"></i></span>
                                            </template>
                                        </SelectButton>
                                    </div>
                                </div>
                            </div>
                        </Panel>
                    </TabPanel>
                    <TabPanel header="Alarme Rücklauf">
                        <Panel header="Alarmeinstellungen Minimum-Temperatur Rücklauf">
                            <template #icons>
                                <i class="fi fi-rr-temperature-low bg-bespin fg-lightYellow p-panel-header-icon text-xl"></i>
                            </template>
                            <div class="formgrid grid p-1">
                                <div class="field col">
                                    <span class="p-float-label mr-2">
                                        <InputNumber id="alarmRlMin" ref="alarmRlMin" :min="-50" :max="150"
                                            v-model="getDiagDataCfg('alarmRlMin').value" mode="decimal"
                                            :suffix="` ${getDiagDataCfg('alarmRlMin').unit}`"
                                            :minFractionDigits="1" :useGrouping="false" locale="de-DE"
                                            @focus="focusElement" class="p-inputtext-lg w-full" />
                                        <label for="alarmRlMin" class="mr-2">{{ getDiagDataCfg('alarmRlMin').label }}</label>
                                    </span>
                                </div>
                                <div class="field col">
                                    <div class="flex justify-content-center">
                                        <SelectButton v-model="getDiagDataCfg('alarmRlMinPrior').value" :options="this.$store.getters.getAlarmPrior" optionLabel="name" optionValue="value" dataKey="value" aria-labelledby="name">
                                            <template #option="slotProps">
                                                <span class="flex justify-content-center mx-auto" v-tooltip="slotProps.option.name"><i :class="slotProps.option.icon" class="text-xl icon-inline"></i></span>
                                            </template>
                                        </SelectButton>
                                    </div>
                                </div>
                            </div>
                            <div class="formgrid grid p-1">
                                <div class="field col">
                                    <span class="p-float-label mr-2">
                                        <InputNumber id="alarmRlMinDiff" ref="alarmRlMinDiff" :min="-150" :max="150"
                                            v-model="getDiagDataCfg('alarmRlMinDiff').value" mode="decimal"
                                            :suffix="` ${getDiagDataCfg('alarmRlMinDiff').unit}`"
                                            :minFractionDigits="1" :useGrouping="false" locale="de-DE"
                                            @focus="focusElement" class="p-inputtext-lg w-full" />
                                        <label for="alarmRlMinDiff" class="mr-2">{{ getDiagDataCfg('alarmRlMinDiff').label }}</label>
                                    </span>
                                </div>
                                <div class="field col">
                                    <TimeInput :id="`alarmRlMinDelay`" v-model="this.getDiagDataCfg('alarmRlMinDelay').value" :label="this.getDiagDataCfg('alarmRlMinDelay').label" :timeMode="-1" />
                                </div>
                            </div>
                        </Panel>
                        <Panel header="Alarmeinstellungen Maximum-Temperatur Rücklauf" class="mt-2">
                            <template #icons>
                                <i class="fi fi-rr-temperature-high bg-bespin fg-lightYellow p-panel-header-icon text-xl"></i>
                            </template>
                            <div class="formgrid grid p-1">
                                <div class="field col">
                                    <span class="p-float-label mr-2">
                                        <InputNumber id="alarmRlMax" ref="alarmRlMax" :min="-50" :max="150"
                                            v-model="getDiagDataCfg('alarmRlMax').value" mode="decimal"
                                            :suffix="` ${getDiagDataCfg('alarmRlMax').unit}`"
                                            :minFractionDigits="1" :useGrouping="false" locale="de-DE"
                                            @focus="focusElement" class="p-inputtext-lg w-full" />
                                        <label for="alarmRlMax" class="mr-2">{{ getDiagDataCfg('alarmRlMax').label }}</label>
                                    </span>
                                </div>
                                <div class="field col">
                                    <div class="flex justify-content-center">
                                        <SelectButton v-model="getDiagDataCfg('alarmRlMaxPrior').value" :options="this.$store.getters.getAlarmPrior" optionLabel="name" optionValue="value" dataKey="value" aria-labelledby="name">
                                            <template #option="slotProps">
                                                <span class="flex justify-content-center mx-auto" v-tooltip="slotProps.option.name"><i :class="slotProps.option.icon" class="text-xl icon-inline"></i></span>
                                            </template>
                                        </SelectButton>
                                    </div>
                                </div>
                            </div>
                            <div class="formgrid grid p-1">
                                <div class="field col">
                                    <span class="p-float-label mr-2">
                                        <InputNumber id="alarmRlMaxDiff" ref="alarmRlMaxDiff" :min="-150" :max="150"
                                            v-model="getDiagDataCfg('alarmRlMaxDiff').value" mode="decimal"
                                            :suffix="` ${getDiagDataCfg('alarmRlMaxDiff').unit}`"
                                            :minFractionDigits="1" :useGrouping="false" locale="de-DE"
                                            @focus="focusElement" class="p-inputtext-lg w-full" />
                                        <label for="alarmRlMaxDiff" class="mr-2">{{ getDiagDataCfg('alarmRlMaxDiff').label }}</label>
                                    </span>
                                </div>
                                <div class="field col">
                                    <TimeInput :id="`alarmRlMaxDelay`" v-model="this.getDiagDataCfg('alarmRlMaxDelay').value" :label="this.getDiagDataCfg('alarmRlMaxDelay').label" :timeMode="-1" />
                                </div>
                            </div>
                        </Panel>
                        <Panel header="Alarmeinstellungen Spreitzung Vorlauf/Rücklauf" class="mt-2">
                            <template #icons>
                                <i class="fi fi-rr-temperature-high bg-bespin fg-lightYellow p-panel-header-icon text-xl"></i>
                            </template>
                            <div class="formgrid grid p-1">
                                <div class="field col">
                                    <span class="p-float-label mr-2">
                                        <InputNumber id="alarmRlDiff" ref="alarmRlDiff" :min="-50" :max="150"
                                            v-model="getDiagDataCfg('alarmRlDiff').value" mode="decimal"
                                            :suffix="` ${getDiagDataCfg('alarmRlDiff').unit}`"
                                            :minFractionDigits="1" :useGrouping="false" locale="de-DE"
                                            @focus="focusElement" class="p-inputtext-lg w-full" />
                                        <label for="alarmRlDiff" class="mr-2">{{ getDiagDataCfg('alarmRlDiff').label }}</label>
                                    </span>
                                </div>
                                <div class="field col">
                                    <div class="flex justify-content-center">
                                        <SelectButton v-model="getDiagDataCfg('alarmRlDiffPrior').value" :options="this.$store.getters.getAlarmPrior" optionLabel="name" optionValue="value" dataKey="value" aria-labelledby="name">
                                            <template #option="slotProps">
                                                <span class="flex justify-content-center mx-auto" v-tooltip="slotProps.option.name"><i :class="slotProps.option.icon" class="text-xl icon-inline"></i></span>
                                            </template>
                                        </SelectButton>
                                    </div>
                                </div>
                            </div>
                            <div class="formgrid grid p-1">
                                <div class="field col">
                                    <span class="p-float-label mr-2">
                                        <InputNumber id="alarmRlDiffDiff" ref="alarmRlDiffDiff" :min="-150" :max="150"
                                            v-model="getDiagDataCfg('alarmRlDiffDiff').value" mode="decimal"
                                            :suffix="` ${getDiagDataCfg('alarmRlDiffDiff').unit}`"
                                            :minFractionDigits="1" :useGrouping="false" locale="de-DE"
                                            @focus="focusElement" class="p-inputtext-lg w-full" />
                                        <label for="alarmRlDiffDiff" class="mr-2">{{ getDiagDataCfg('alarmRlDiffDiff').label }}</label>
                                    </span>
                                </div>
                                <div class="field col">
                                    <TimeInput :id="`alarmRlDiffDelay`" v-model="this.getDiagDataCfg('alarmRlDiffDelay').value" :label="this.getDiagDataCfg('alarmRlDiffDelay').label" :timeMode="-1" />
                                </div>
                            </div>
                        </Panel>
                        <Panel header="Alarmeinstellungen Sensoralarm Rücklauf" class="mt-3" v-if="isMaster">
                            <template #icons>
                                <i class="fi fi-rr-temperature-low bg-bespin fg-lightYellow p-panel-header-icon text-xl"></i>
                            </template>
                            <div class="formgrid grid p-1">
                                <div class="field col">
                                    <span class="p-float-label mr-2">
                                        <InputNumber id="alarmRlSensorDiff" ref="alarmRlSensorDiff" :min="-150" :max="150"
                                            v-model="getDiagDataCfg('alarmRlSensorDiff').value" mode="decimal"
                                            :suffix="` ${getDiagDataCfg('alarmRlSensorDiff').unit}`"
                                            :minFractionDigits="1" :useGrouping="false" locale="de-DE"
                                            @focus="focusElement" class="p-inputtext-lg w-full" />
                                        <label for="alarmRlSensorDiff" class="mr-2">{{ getDiagDataCfg('alarmRlSensorDiff').label }}</label>
                                    </span>
                                </div>
                                <div class="field col">
                                    <TimeInput :id="`alarmRlSensorDelay`" v-model="this.getDiagDataCfg('alarmRlSensorDelay').value" :label="this.getDiagDataCfg('alarmRlSensorDelay').label" :timeMode="-1" />
                                </div>
                            </div>
                            <div class="formgrid grid p-1">
                                <div class="field col">
                                    <div class="flex justify-content-center">
                                        <SelectButton v-model="getDiagDataCfg('alarmRlSensorPrior').value" :options="this.$store.getters.getAlarmPrior" optionLabel="name" optionValue="value" dataKey="value" aria-labelledby="name">
                                            <template #option="slotProps">
                                                <span class="flex justify-content-center mx-auto" v-tooltip="slotProps.option.name"><i :class="slotProps.option.icon" class="text-xl icon-inline"></i></span>
                                            </template>
                                        </SelectButton>
                                    </div>
                                </div>
                            </div>
                        </Panel>
                    </TabPanel>
                    <TabPanel header="Sensoreinstellungen" v-if="isMaster">
                        <Panel header="Filtereinstellungen" class="mt-0">
                            <template #icons>
                                <i class="fi fi-rr-settings bg-bespin fg-lightYellow p-panel-header-icon text-xl"></i>
                            </template>
                            <div class="formgrid grid p-1">
                                <div class="field col">
                                    <div class="field">
                                        <span class="p-float-label mr-2">
                                            <InputNumber id="tempFilterTime" ref="tempFilterTime" :min="0" :max="100000"
                                                v-model="this.getDiagDataCfg('tempFilterTime').value" mode="decimal"
                                                :suffix="` ${this.getDiagDataCfg('tempFilterTime').unit}`"
                                                :minFractionDigits="0" :useGrouping="false" locale="de-DE"
                                                @focus="focusElement" class="p-inputtext-lg w-full" />
                                            <label for="tempFilterTime" class="mr-2">{{ this.getDiagDataCfg('tempFilterTime').label }}</label>
                                        </span>
                                    </div>
                                </div>
                                <div class="field col">
                                    <div class="field">
                                        <span class="p-float-label mr-2">
                                            <InputNumber id="tempFilterValue" ref="tempFilterValue" :min="0" :max="1"
                                                v-model="this.getDiagDataCfg('tempFilterValue').value" mode="decimal"
                                                :suffix="` ${this.getDiagDataCfg('tempFilterValue').unit}`"
                                                :minFractionDigits="3" :useGrouping="false" locale="de-DE"
                                                @focus="focusElement" class="p-inputtext-lg w-full" />
                                            <label for="tempFilterValue" class="mr-2">{{ this.getDiagDataCfg('tempFilterValue').label }}</label>
                                        </span>
                                    </div>
                                </div>
                            </div>
                            <div class="formgrid grid p-1">
                                <div class="field col">
                                    <div class="field">
                                        <span class="p-float-label mr-2">
                                            <InputNumber id="calcFilterTime" ref="calcFilterTime" :min="0" :max="100000"
                                                v-model="this.getDiagDataCfg('calcFilterTime').value" mode="decimal"
                                                :suffix="` ${this.getDiagDataCfg('calcFilterTime').unit}`"
                                                :minFractionDigits="0" :useGrouping="false" locale="de-DE"
                                                @focus="focusElement" class="p-inputtext-lg w-full" />
                                            <label for="calcFilterTime" class="mr-2">{{ this.getDiagDataCfg('calcFilterTime').label }}</label>
                                        </span>
                                    </div>
                                </div>
                                <div class="field col">
                                    <div class="field">
                                        <span class="p-float-label mr-2">
                                            <InputNumber id="calcFilterValue" ref="calcFilterValue" :min="0" :max="10000"
                                                v-model="this.getDiagDataCfg('calcFilterValue').value" mode="decimal"
                                                :suffix="` ${this.getDiagDataCfg('calcFilterValue').unit}`"
                                                :minFractionDigits="3" :useGrouping="false" locale="de-DE"
                                                @focus="focusElement" class="p-inputtext-lg w-full" />
                                            <label for="calcFilterValue" class="mr-2">{{ this.getDiagDataCfg('calcFilterValue').label }}</label>
                                        </span>
                                    </div>
                                </div>
                            </div>
                            <div class="formgrid grid p-1">
                                <div class="field col">
                                    <div class="field">
                                        <span class="p-float-label mr-2">
                                            <InputNumber id="filterTypeVlSet" ref="filterTypeVlSet" :min="0" :max="10"
                                                v-model="this.getDiagDataCfg('filterTypeVlSet').value" mode="decimal"
                                                :suffix="` ${this.getDiagDataCfg('filterTypeVlSet').unit}`"
                                                :minFractionDigits="0" :useGrouping="false" locale="de-DE"
                                                @focus="focusElement" class="p-inputtext-lg w-full" />
                                            <label for="filterTypeVlSet" class="mr-2">{{ this.getDiagDataCfg('filterTypeVlSet').label }}</label>
                                        </span>
                                    </div>
                                </div>
                            </div>
                            <div class="formgrid grid p-1">
                                <div class="field col">
                                    <TimeInput :id="`ctrlDelay`" v-model="this.getDiagDataCfg('ctrlDelay').value" :label="this.getDiagDataCfg('ctrlDelay').label" :timeMode="-1" />
                                </div>
                                <div class="field col">
                                    <TimeInput :id="`setpointDelay`" v-model="this.getDiagDataCfg('setpointDelay').value" :label="this.getDiagDataCfg('setpointDelay').label" :timeMode="-1" />
                                </div>
                            </div>
                        </Panel>
                        <Panel header="Sensorskalierung Vorlauffühler" class="mt-3">
                            <template #icons>
                                <i class="fi fi-rr-cog bg-bespin fg-lightYellow p-panel-header-icon text-xl"></i>
                            </template>
                            <div class="formgrid grid p-1">
                                <div class="field col">
                                    <div class="field">
                                        <span class="p-float-label mr-2">
                                            <InputNumber id="vlSensInMin" ref="vlSensInMin" :min="0" :max="32767"
                                                v-model="this.getDiagDataCfg('vlSensInMin').value" mode="decimal"
                                                :minFractionDigits="0" :useGrouping="false" locale="de-DE"
                                                @focus="focusElement" class="p-inputtext-lg w-full" />
                                            <label for="vlSensInMin" class="mr-2">Sensor IN Untergrenze</label>
                                        </span>
                                    </div>
                                </div>
                                <div class="field col">
                                    <div class="field">
                                        <span class="p-float-label mr-2">
                                            <InputNumber id="vlSensOutMin" ref="vlSensOutMin" :min="-1000" :max="1000"
                                                v-model="this.getDiagDataCfg('vlSensOutMin').value"
                                                :suffix="` ${this.getDiagDataCfg('vlSensOutMin').unit}`"
                                                :minFractionDigits="1" :useGrouping="false" locale="de-DE"
                                                @focus="focusElement" class="p-inputtext-lg w-full" />
                                            <label for="vlSensOutMin" class="mr-2">Sensor OUT Untergrenze</label>
                                        </span>
                                    </div>
                                </div>
                            </div>
                            <div class="formgrid grid p-1">
                                <div class="field col">
                                    <div class="field">
                                        <span class="p-float-label mr-2">
                                            <InputNumber id="vlSensInMax" ref="vlSensInMax" :min="0" :max="32767"
                                                v-model="this.getDiagDataCfg('vlSensInMax').value" mode="decimal"
                                                :minFractionDigits="0" :useGrouping="false" locale="de-DE"
                                                @focus="focusElement" class="p-inputtext-lg w-full" />
                                            <label for="vlSensInMax" class="mr-2">Sensor IN Obergrenze</label>
                                        </span>
                                    </div>
                                </div>
                                <div class="field col">
                                    <div class="field">
                                        <span class="p-float-label mr-2">
                                            <InputNumber id="vlSensOutMax" ref="vlSensOutMax" :min="-1000" :max="1000"
                                                v-model="this.getDiagDataCfg('vlSensOutMax').value"
                                                :suffix="` ${this.getDiagDataCfg('vlSensOutMax').unit}`"
                                                :minFractionDigits="1" :useGrouping="false" locale="de-DE"
                                                @focus="focusElement" class="p-inputtext-lg w-full" />
                                            <label for="vlSensOutMax" class="mr-2">Sensor OUT Obergrenze</label>
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </Panel>
                        <Panel header="Sensorskalierung Rücklauffühler" class="mt-3">
                            <template #icons>
                                <i class="fi fi-rr-cog bg-bespin fg-lightYellow p-panel-header-icon text-xl"></i>
                            </template>
                            <div class="formgrid grid p-1">
                                <div class="field col">
                                    <div class="field">
                                        <span class="p-float-label mr-2">
                                            <InputNumber id="rlSensInMin" ref="rlSensInMin" :min="0" :max="32767"
                                                v-model="this.getDiagDataCfg('rlSensInMin').value" mode="decimal"
                                                :minFractionDigits="0" :useGrouping="false" locale="de-DE"
                                                @focus="focusElement" class="p-inputtext-lg w-full" />
                                            <label for="rlSensInMin" class="mr-2">Sensor IN Untergrenze</label>
                                        </span>
                                    </div>
                                </div>
                                <div class="field col">
                                    <div class="field">
                                        <span class="p-float-label mr-2">
                                            <InputNumber id="rlSensOutMin" ref="rlSensOutMin" :min="-1000" :max="1000"
                                                v-model="this.getDiagDataCfg('rlSensOutMin').value"
                                                :suffix="` ${this.getDiagDataCfg('rlSensOutMin').unit}`"
                                                :minFractionDigits="1" :useGrouping="false" locale="de-DE"
                                                @focus="focusElement" class="p-inputtext-lg w-full" />
                                            <label for="rlSensOutMin" class="mr-2">Sensor OUT Untergrenze</label>
                                        </span>
                                    </div>
                                </div>
                            </div>
                            <div class="formgrid grid p-1">
                                <div class="field col">
                                    <div class="field">
                                        <span class="p-float-label mr-2">
                                            <InputNumber id="rlSensInMax" ref="rlSensInMax" :min="0" :max="32767"
                                                v-model="this.getDiagDataCfg('rlSensInMax').value" mode="decimal"
                                                :minFractionDigits="0" :useGrouping="false" locale="de-DE"
                                                @focus="focusElement" class="p-inputtext-lg w-full" />
                                            <label for="rlSensInMax" class="mr-2">Sensor IN Obergrenze</label>
                                        </span>
                                    </div>
                                </div>
                                <div class="field col">
                                    <div class="field">
                                        <span class="p-float-label mr-2">
                                            <InputNumber id="rlSensOutMax" ref="rlSensOutMax" :min="-1000" :max="1000"
                                                v-model="this.getDiagDataCfg('rlSensOutMax').value"
                                                :suffix="` ${this.getDiagDataCfg('rlSensOutMax').unit}`"
                                                :minFractionDigits="1" :useGrouping="false" locale="de-DE"
                                                @focus="focusElement" class="p-inputtext-lg w-full" />
                                            <label for="rlSensOutMax" class="mr-2">Sensor OUT Obergrenze</label>
                                        </span>
                                    </div>
                                </div>
                            </div>
                            <div class="formgrid grid p-1">
                                <div class="field col">
                                    <div class="field">
                                        <span class="p-float-label mr-2">
                                            <InputNumber id="rlSensOffset" ref="rlSensOffset" :min="-1000" :max="1000"
                                                v-model="this.getDiagDataCfg('rlSensOffset').value"
                                                :suffix="` ${this.getDiagDataCfg('rlSensOffset').unit}`"
                                                :minFractionDigits="1" :useGrouping="false" locale="de-DE"
                                                @focus="focusElement" class="p-inputtext-lg w-full" />
                                            <label for="rlSensOffset" class="mr-2">{{ this.getDiagDataCfg('rlSensOffset').label }}</label>
                                        </span>
                                    </div>
                                </div>
                            </div>
                            <div class="formgrid grid p-1">
                                <div class="field col">
                                    <div class="field mt-2">
                                        <span class="p-float-label mr-2">
                                            <InputNumber id="IN_RL" ref="IN_RL"
                                                v-model="this.getModuleValue('IN_RL').value" mode="decimal"
                                                :suffix="` ${this.getModuleValue('IN_RL').unit}`"
                                                :minFractionDigits="0" :useGrouping="false" locale="de-DE"
                                                class="p-inputtext-lg w-full" :disabled="true" />
                                            <label for="IN_RL" class="mr-2">{{ this.getModuleValue('IN_RL').label }}</label>
                                        </span>
                                    </div>
                                </div>
                                <div class="field col">
                                    <div class="field mt-2">
                                        <span class="p-float-label mr-2">
                                            <InputNumber id="OUT_RL" ref="OUT_RL"
                                                v-model="this.getModuleValue('OUT_RL').value" mode="decimal"
                                                :suffix="` ${this.getModuleValue('OUT_RL').unit}`"
                                                :minFractionDigits="1" :useGrouping="false" locale="de-DE"
                                                class="p-inputtext-lg w-full" :disabled="true" />
                                            <label for="OUT_RL" class="mr-2">{{ this.getModuleValue('OUT_RL').label }}</label>
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </Panel>
                    </TabPanel>
                    <TabPanel header="Stetiges Ventil" v-if="isMaster">
                        <Panel header="Analoger Ausgang Vorlaufmischer" class="mt-3">
                            <template #icons>
                                <i class="fi fi-rr-settings bg-bespin fg-lightYellow p-panel-header-icon text-xl"></i>
                            </template>
                            <div class="formgrid grid p-1">
                                <div class="field col">
                                    <div class="field">
                                        <span class="p-float-label mr-2">
                                            <InputNumber id="valveSetpointInMin" ref="valveSetpointInMin" :min="-1000" :max="1000"
                                                v-model="this.getDiagDataCfg('valveSetpointInMin').value"
                                                :suffix="` ${this.getDiagDataCfg('valveSetpointInMin').unit}`"
                                                :minFractionDigits="1" :useGrouping="false" locale="de-DE"
                                                @focus="focusElement" class="p-inputtext-lg w-full" />
                                            <label for="valveSetpointInMin" class="mr-2">{{ getDiagDataCfg('valveSetpointInMin').label }}</label>
                                        </span>
                                    </div>
                                </div>
                                <div class="field col">
                                    <div class="field">
                                        <span class="p-float-label mr-2">
                                            <InputNumber id="valveSetpointOutMin" ref="valveSetpointOutMin" :min="0" :max="32767"
                                                v-model="this.getDiagDataCfg('valveSetpointOutMin').value" mode="decimal"
                                                :minFractionDigits="0" :useGrouping="false" locale="de-DE"
                                                @focus="focusElement" class="p-inputtext-lg w-full" />
                                            <label for="valveSetpointOutMin" class="mr-2">{{ getDiagDataCfg('valveSetpointOutMin').label }}</label>
                                        </span>
                                    </div>
                                </div>
                            </div>
                            <div class="formgrid grid p-1">
                                <div class="field col">
                                    <div class="field">
                                        <span class="p-float-label mr-2">
                                            <InputNumber id="valveSetpointInMax" ref="valveSetpointInMax" :min="-1000" :max="1000"
                                                v-model="this.getDiagDataCfg('valveSetpointInMax').value"
                                                :suffix="` ${this.getDiagDataCfg('valveSetpointInMax').unit}`"
                                                :minFractionDigits="1" :useGrouping="false" locale="de-DE"
                                                @focus="focusElement" class="p-inputtext-lg w-full" />
                                            <label for="valveSetpointInMax" class="mr-2">{{ getDiagDataCfg('valveSetpointInMax').label }}</label>
                                        </span>
                                    </div>
                                </div>
                                <div class="field col">
                                    <div class="field">
                                        <span class="p-float-label mr-2">
                                            <InputNumber id="valveSetpointOutMax" ref="valveSetpointOutMax" :min="0" :max="32767"
                                                v-model="this.getDiagDataCfg('valveSetpointOutMax').value" mode="decimal"
                                                :minFractionDigits="0" :useGrouping="false" locale="de-DE"
                                                @focus="focusElement" class="p-inputtext-lg w-full" />
                                            <label for="valveSetpointOutMax" class="mr-2">{{ getDiagDataCfg('valveSetpointOutMax').label }}</label>
                                        </span>
                                    </div>
                                </div>
                            </div>
                            <div class="formgrid grid p-1">
                                <div class="field col">
                                    <div class="field">
                                        <span class="p-float-label mr-2">
                                            <InputNumber id="valveSetpointOffset" ref="valveSetpointOffset" :min="-10000" :max="10000"
                                                v-model="this.getDiagDataCfg('valveSetpointOffset').value" mode="decimal"
                                                :minFractionDigits="1" :useGrouping="false" locale="de-DE"
                                                @focus="focusElement" class="p-inputtext-lg w-full" />
                                            <label for="valveSetpointOffset" class="mr-2">{{ getDiagDataCfg('valveSetpointOffset').label }}</label>
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </Panel>
                        <Panel header="Analoger Ausgang Rücklaufmischer" class="mt-3">
                            <template #icons>
                                <i class="fi fi-rr-settings bg-bespin fg-lightYellow p-panel-header-icon text-xl"></i>
                            </template>
                            <div class="formgrid grid p-1">
                                <div class="field col">
                                    <div class="field">
                                        <span class="p-float-label mr-2">
                                            <InputNumber id="valveRlSetpointInMin" ref="valveRlSetpointInMin" :min="-1000" :max="1000"
                                                v-model="this.getDiagDataCfg('valveRlSetpointInMin').value"
                                                :suffix="` ${this.getDiagDataCfg('valveRlSetpointInMin').unit}`"
                                                :minFractionDigits="1" :useGrouping="false" locale="de-DE"
                                                @focus="focusElement" class="p-inputtext-lg w-full" />
                                            <label for="valveRlSetpointInMin" class="mr-2">{{ getDiagDataCfg('valveRlSetpointInMin').label }}</label>
                                        </span>
                                    </div>
                                </div>
                                <div class="field col">
                                    <div class="field">
                                        <span class="p-float-label mr-2">
                                            <InputNumber id="valveRlSetpointOutMin" ref="valveRlSetpointOutMin" :min="0" :max="32767"
                                                v-model="this.getDiagDataCfg('valveRlSetpointOutMin').value" mode="decimal"
                                                :minFractionDigits="0" :useGrouping="false" locale="de-DE"
                                                @focus="focusElement" class="p-inputtext-lg w-full" />
                                            <label for="valveRlSetpointOutMin" class="mr-2">{{ getDiagDataCfg('valveRlSetpointOutMin').label }}</label>
                                        </span>
                                    </div>
                                </div>
                            </div>
                            <div class="formgrid grid p-1">
                                <div class="field col">
                                    <div class="field">
                                        <span class="p-float-label mr-2">
                                            <InputNumber id="valveRlSetpointInMax" ref="valveRlSetpointInMax" :min="-1000" :max="1000"
                                                v-model="this.getDiagDataCfg('valveRlSetpointInMax').value"
                                                :suffix="` ${this.getDiagDataCfg('valveRlSetpointInMax').unit}`"
                                                :minFractionDigits="1" :useGrouping="false" locale="de-DE"
                                                @focus="focusElement" class="p-inputtext-lg w-full" />
                                            <label for="valveRlSetpointInMax" class="mr-2">{{ getDiagDataCfg('valveRlSetpointInMax').label }}</label>
                                        </span>
                                    </div>
                                </div>
                                <div class="field col">
                                    <div class="field">
                                        <span class="p-float-label mr-2">
                                            <InputNumber id="valveRlSetpointOutMax" ref="valveRlSetpointOutMax" :min="0" :max="32767"
                                                v-model="this.getDiagDataCfg('valveRlSetpointOutMax').value" mode="decimal"
                                                :minFractionDigits="0" :useGrouping="false" locale="de-DE"
                                                @focus="focusElement" class="p-inputtext-lg w-full" />
                                            <label for="valveRlSetpointOutMax" class="mr-2">{{ getDiagDataCfg('valveRlSetpointOutMax').label }}</label>
                                        </span>
                                    </div>
                                </div>
                            </div>
                            <div class="formgrid grid p-1">
                                <div class="field col">
                                    <div class="field">
                                        <span class="p-float-label mr-2">
                                            <InputNumber id="valveRlSetpointOffset" ref="valveRlSetpointOffset" :min="-10000" :max="10000"
                                                v-model="this.getDiagDataCfg('valveRlSetpointOffset').value" mode="decimal"
                                                :minFractionDigits="1" :useGrouping="false" locale="de-DE"
                                                @focus="focusElement" class="p-inputtext-lg w-full" />
                                            <label for="valveRlSetpointOffset" class="mr-2">{{ getDiagDataCfg('valveRlSetpointOffset').label }}</label>
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </Panel>
                    </TabPanel>
                    <TabPanel header="Alarmausgang" v-if="isMaster">
                        <widgetAlarmOutput :value="this.getDiagDataCfg('alarmAssignedOutput')" @setOutput="($value) => {this.getDiagDataCfg('alarmAssignedOutput').value = $value}"></widgetAlarmOutput>
                    </TabPanel>
                </TabView>
            </div>
            <template #footer>
                <widgetDialogFooter :widgetName="`${this.$options.name}_misc`" :department="moduleDepartment.key" :exchange="true" format="json"
                    @diagAbort="diagToggleMisc"
                    @diagSave="saveDiag('misc')"
                    @import="($value) => {this.nodeDataCfg = $value}"
                    :exportObject="this.nodeDataCfg"
                ></widgetDialogFooter>
            </template>
        </Dialog>

        <div v-if="!isLoading">
            <div class="flex justify-content-between align-items-center p-0 flex-wrap">
                <div class="flex justify-content-start align-items-center p-0">
                    <moduleIconEnat :icon="moduleData.metadata.icon" :alarmStatus="alarmStatus" :alarmQueue="alarmQueue" @toogleAlarmOverlay="toogleAlarmOverlay"></moduleIconEnat>
                    <div class="hidden sm:flex mt-1 ml-2">
                        <widget-mini-progress label="Mischer" :value="getModuleValue('OUT_Position')"></widget-mini-progress>
                        <widget-mini-progress label="RL" :value="getModuleValue('OUT_PositionRl')" v-if="this.getModuleValue('CFG.enableRlControl').value === true"></widget-mini-progress>
                        <widget-mini-binary-pulse label="UWP" :value="this.getModuleValue('OUT_UWP')"></widget-mini-binary-pulse>
                        <widget-mini-binary-pulse label="UWP2" :value="this.getModuleValue('OUT_Stage2')" v-if="this.getModuleValue('CFG.useStage2').value === true"></widget-mini-binary-pulse>
                        <widget-mini-binary-pulse label="Bedarf" :value="this.getModuleValue('OUT_ExtRequest')" v-if="this.getModuleValue('CFG.enableExternRequest').value === true"></widget-mini-binary-pulse>
                    </div>
                    <div class="flex flex-column mt-3">

                    </div>
                </div>
                <div class="flex justify-content-end align-items-center p-0">
                    <widget-header :value="this.getModuleValue('OUT_VL')" :moduleData="this.moduleData" @showChart="showChart('value1')" :fgColor="fontColor" />
                </div>
            </div>

            <div class="stats flex mt-1">
                <!-- <div class="left flex flex-column"> -->
                <div class="left">
                    <ul class="widget-list">
                        <Widget_rowValues2 :title="'Mischer Ist/Soll'" :value1="this.getModuleValue('OUT_Position')" :value2="this.getModuleValue('OUT_PositionSetpoint')"></Widget_rowValues2>
                        <Widget_rowValues2 :title="'Vorlauf Ist/Soll'" :value1="this.getModuleValue('OUT_VL')" :value2="this.getModuleValue('OUT_SetpointVl')"></Widget_rowValues2>
                        <Widget_rowValues2 :title="'Differenz VL/HK-Temp'" :value1="this.getModuleValue('OUT_DiffVl')" :value2="this.getModuleValue('OUT_HkTemp')"></Widget_rowValues2>
                        <Widget_rowValues2 :title="'Rücklauf Ist/Soll'" :value1="this.getModuleValue('OUT_RL')" :value2="this.getModuleValue('OUT_SetpointRl')" v-if="this.getModuleValue('CFG.enableRlControl').value === true"></Widget_rowValues2>
                        <Widget_rowValues2 :title="'Spreitzung/Diff.RL'" :value1="this.getModuleValue('OUT_Spreading')" :value2="this.getModuleValue('OUT_DiffRl')" v-if="this.getModuleValue('CFG.enableRlControl').value === true"></Widget_rowValues2>
                    </ul>
                </div>
                <div class="right flex flex-column">
                    <div class="flex flex-wrap">
                        <div class="flex-1 align-items-center justify-content-center mt-3">
                            <button-enat title="Heizperioden" subtitle="Einstellungen Heizungstemperaturen" icon="fi fi-rr-time-twenty-four" fgColor="yellow" bgColor="crimson"
                                :badge="getModuleValue('OUT_CurrentPeriod.periodIndex').value + 1" @click="toggleOP($event, 'periods')" :loadState="this.loadDiagPeriods" :disabled="this.showDiagPeriods">
                            </button-enat>
                        </div>
                        <div class="flex-1 align-items-center justify-content-center mt-3">
                            <button-enat title="Allgemein" subtitle="Alarme, Meldungen" icon="fi fi-rr-settings" fgColor="yellow" bgColor="darkSteel"
                                @click="toggleOP($event, 'misc')" :loadState="this.loadDiagMisc" :disabled="this.showDiagMisc">
                            </button-enat>
                        </div>
                    </div>
                    <div class="flex flex-wrap mt-2">
                        <div class="flex-1 align-items-center justify-content-center mr-1 mt-1">
                            <valuebox-enat title="aktuelle Periode" :value="getModuleValue('OUT_CurrentPeriod.periodName').value" :moduleData="moduleData" icon="fi fi-rr-time-twenty-four" />
                        </div>
                    </div>
                    <div class="flex flex-wrap">
                        <div class="flex-1 align-items-center justify-content-center mr-1 mt-1">
                            <valuebox-enat title="VL-MIN" :value="getModuleValueStr('OUT_CurrentPeriod.vlMinTemp')" :moduleData="moduleData" icon="fi fi-rr-temperature-down" />
                        </div>
                        <div class="flex-1 align-items-center justify-content-center mr-1 mt-1">
                            <valuebox-enat title="VL-MAX" :value="getModuleValueStr('OUT_CurrentPeriod.vlMaxTemp')" :moduleData="moduleData" icon="fi fi-rr-temperature-up" />
                        </div>
                    </div>
                    <div class="flex flex-wrap" v-if="this.getModuleValue('CFG.enableRlControl').value === true">
                        <div class="flex-1 align-items-center justify-content-center mr-1 mt-1">
                            <valuebox-enat title="RL-MIN" :value="getModuleValueStr('OUT_CurrentPeriod.rlMinTemp')" :moduleData="moduleData" icon="fi fi-rr-temperature-down" />
                        </div>
                        <div class="flex-1 align-items-center justify-content-center mr-1 mt-1">
                            <valuebox-enat title="RL-MAX" :value="getModuleValueStr('OUT_CurrentPeriod.rlMaxTemp')" :moduleData="moduleData" icon="fi fi-rr-temperature-up" />
                        </div>
                    </div>
                </div>
            </div>
            <textbox-enat title="Status" :value="currentStatusStr" :moduleData="moduleData" icon="fi fi-rr-comment-alt" />
        </div>
        <Dialog 
            v-model:visible="showDiagName"
            :closable="false"
            :breakpoints="{ '960px': '75vw', '640px': '90vw' }"
            :style="{ width: '450px' }"
            :modal="true"
            class="p-fluid"
        >
            <template #header>
                <p class="nice-font"><i class="fi fi-rr-text"></i><span class="pl-1 mt-1">Bezeichnung ändern</span></p>
            </template>
            <div @keydown.esc="hideNameDiag" @keydown.enter="saveNameDiag(changeDiagName)">
                <Panel>
                    <div class="grid p-fluid">
                        <div class="col-12 pl-5 pr-5">
                            <span class="p-float-label mr-2">
                                <InputText id="periodName" ref="periodName" v-model="changeDiagName.value" locale="de-DE" class="nice-font inputtext-param text-center text-2xl" />
                                <label for="periodName" class="mr-2">Bezeichnung</label>
                            </span>
                        </div>
                    </div>
                </Panel>
            </div>
            <template #footer>
            <Button label="Abbrechen" icon="pi pi-times" class="p-button-text" @click="hideNameDiag" />
            <Button label="Speichern" icon="pi pi-check" class="p-button-text" @click="saveNameDiag(changeDiagName)" />
            </template>
        </Dialog>
        <div v-if="entryDialog === true">
            <dialog-io-single v-bind:showDialog="entryDialog" :dialogObj="ioObj" v-bind:dialogData="ioDialogData"
                @entrySave="
                    ($value) => {
                        changeVal($value);
                    }
                " @entryAbort="hideDialog()"></dialog-io-single>
        </div>
        <div v-if="entryDialog === true">
            <dialog-io-single v-bind:showDialog="entryDialog" :dialogObj="ioObj" v-bind:dialogData="ioDialogData"
                @entrySave="
                    ($value) => {
                        changeVal($value);
                    }
                " @entryAbort="hideDialog()"></dialog-io-single>
        </div>
        <dialog-chart-single :icon="getModuleValue('OUT_VL').icon" :node="getModuleValue('OUT_VL')" v-bind:show="showChart1" @chart-close="showChart1 = false"></dialog-chart-single>
        <dialog-chart-single :icon="getModuleValue('OUT_Position').icon" :node="getModuleValue('OUT_Position')" v-bind:show="showChartValve" @chart-close="showChartValve = false"></dialog-chart-single>
        <dialog-chart-single :icon="getModuleValue('OUT_UWP').icon" :node="getModuleValue('OUT_UWP')" v-bind:show="showChartPump" @chart-close="showChartPump = false"></dialog-chart-single>
    </div>
</template>

<script>
import { defineComponent } from 'vue';
import store from '@/store';
import { mapGetters, mapActions } from 'vuex';
import helpers from '@/helpers';
import { parseNode, setOpcValueToast } from '@/helpers';
import SocketioService from '@/services/socketioService.js';
import Widget_rowValues2 from '@/components/fragments/widget_rowValues2.vue';
import dialogChartSingle from '@/components/dialog/chartSingle.vue';
import widgetMiniProgress from '@/components/fragments/widgetMiniProgress.vue';
import widgetMiniBinaryPulse from '@/components/fragments/widgetMiniBinaryPulse.vue';
import widgetAlarmOutput from '@/components/fragments/widgetAlarmOutput.vue';
import widgetDialogFooter from '@/components/fragments/widgetDialogFooter.vue';
import moduleIconEnat from '@/components/fragments/moduleIconEnat.vue';
import widgetTitleBar from '@/components/fragments/widgetTitleBar.vue';
import moduleDialogIconHelp from '@/components/fragments/moduleDialogIconHelp.vue';
// import widgetTimeSet from '@/components/fragments/widgetTimeSet.vue';

export default defineComponent({
    name: 'widgetHeatingTransportController',
    setup() { },
    components: {
        Widget_rowValues2,
        dialogChartSingle,
        widgetMiniProgress,
        widgetMiniBinaryPulse,
        widgetAlarmOutput,
        widgetDialogFooter,
        moduleIconEnat,
        widgetTitleBar,
        moduleDialogIconHelp,
    },
    props: {
        content: {
            type: null,
            required: true,
        },
        dragObj: {
            type: null,
            required: false,
        },
        valueObj: {
            type: null,
            required: false,
        },
        dataObj: {
            type: null,
            required: false,
        },
        styleObj: {
            type: null,
            required: false,
        },
        createdLayout: {
            type: Boolean,
            required: false,
        },
        readyLayout: {
            type: Boolean,
            required: false,
        },
    },
    watch: {
        createdLayout() {
            this.watchCreatedLayout();
        },
        readyLayout() {
            this.watchLayout();
        },
        '$store.getters.getPageData.editMode': function () {
            this.checkEditMode();
        },
        // nodeEntry: {
        //     handler: function(entry) {
        //         // this.filterParameters();
        //         // if (Array.isArray(entries) && entries.length > 0) {
        //         //     this.loading = false;
        //         // } else {
        //         //     this.loading = true;
        //         // }
        //     },
        //     deep: true
        // }
    },
    computed: {
        ...mapGetters({
            editMode: 'getEditMode',
            getNodeWidget: 'getNodeWidget',
            getOneDepartment: 'types/getOneDepartment',
            getOneCategory: 'types/getOneCategory',
            getIoTree: 'getIoTree',
            getStyleColors: 'getStyleColors',
            getStylePatterns: 'getStylePatterns',
            getModules: 'opcua/getModules',
            getModule: 'opcua/getModule',
            getNode: 'opcua/getNode',
            getModuleFetched: 'opcua/getModuleFetched',
            isMaster: 'auth/isMaster',
            getHelpText: 'types/getHelpText',
        }),
        isLoading: function() {
            if (!this.moduleData || !this.getModuleFetched(this.moduleHash) || this.loading) return true;
            return false;
        },
        
        connectedModule: function () {
            if (this.content.data.module) {
                return this.content.data.module;
            }
            return null;
        },
        moduleData: function () {
            if (this.connectedModule) {
                const module = this.getModule(this.connectedModule);
                if (module) return module;
            }
            return null;
        },
        moduleHash: function () {
            if (this.moduleData !== null) {
                if (this.moduleData.source.server !== null && this.moduleData.source.identifier !== null) {
                    return `${this.moduleData.source.server}@${this.moduleData.source.identifier}`
                }
            }
            return null;
        },
        moduleDepartment: function () {
            if (this.moduleData !== null) {
                if (this.moduleData.metadata.department !== null) {
                    return this.getOneDepartment(this.moduleData.metadata.department);
                }
            }
            return { key: store.getters.getNoval, label: store.getters.getNoval };
        },
        moduleCategory: function () {
            if (this.moduleData !== null) {
                if (this.moduleData.metadata.category !== null) {
                    return this.getOneDepartment(this.moduleData.metadata.category);
                }
            }
            return { key: store.getters.getNoval, label: store.getters.getNoval };
        },
        componentName: function () {
            if (this.content.name !== undefined) {
                return this.content.name;
            } else {
                return '???';
            }
        },
        componentLabel: function () {
            if (this.content.label !== undefined) {
                return this.content.label;
            } else if (this.moduleData !== null && this.moduleData.metadata.label) {
                return this.moduleData.metadata.label;
            } else {
                return store.getters.getNoval;
            }
        },
        componentContent: function () {
            if (this.content.content !== undefined) {
                return this.content.content;
            } else {
                return '???';
            }
        },
        componentStyle: function () {
            if (this.content.style && this.content.style !== 'standard') {
                let background = `bg-${this.content.style.background}`;
                if (this.alarmStatus > 0) background = 'alarm';
                return `box ptrn-${this.content.style.pattern} ${background} fg-${this.content.style.foreground}`;
            } else {
                return '';
            }
        },
        fontColor: function () {
            if (this.content.style && this.content.style.foreground) {
                return `fg-${this.content.style.foreground}`;
            }
            return 'gray';
        },
        icon: function () {
            if (this.alarmStatus === 0) {
                return this.moduleData.metadata.icon
            } else {
                return `${this.moduleData.metadata.icon} fg-red pulse-loop cursor-pointer bg-lightCrimson`;
            }
        },
        alarmEntriesCount: function () {
            if (this.getModuleValue(`AlarmEntriesCount`).value > 0) {
                return this.getModuleValue(`AlarmEntriesCount`).value;
            } else {
                return 0;
            }
        },
        alarmStatus: function () {
            let alarmCount = this.alarmEntriesCount;
            for (let i=0; i<this.alarmEntriesCount; i++) {
                // console.log(this.getModuleValue(`AlarmEntries[${i}].OUT_AlarmState`));
                if (this.getModuleValue(`AlarmEntries[${i}].OUT_AlarmState`).value <= 0) {
                    alarmCount -= 1;
                }
            }
            return alarmCount;
        },
        alarmQueue: function () {
            let alarmCount = this.alarmEntriesCount;
            for (let i=0; i<this.alarmEntriesCount; i++) {
                // console.log(this.getModuleValue(`AlarmEntries[${i}].OUT_AlarmState`));
                if (this.getModuleValue(`AlarmEntries[${i}].OUT_AlarmState`).value === 0) {
                    alarmCount -= 1;
                }
            }
            return alarmCount;
        },
        alarmList: function () {
            let activeAlarms = [];
            for (let i=0; i<this.alarmEntriesCount; i++) {
                if (this.getModuleValue(`AlarmEntries[${i}].OUT_AlarmState`).value !== 0) {
                    const alarm = {
                        label: this.getModuleValue(`AlarmEntries[${i}].CFG.alarmLabel`).value,
                        state: this.getModuleValue(`AlarmEntries[${i}].OUT_AlarmState`).value
                    }
                    activeAlarms.push(alarm);
                }
            }
            return activeAlarms;
        },
        alarmTicker: function () {
            let alarmStr = '';
            for (let i=0; i<this.alarmEntriesCount; i++) {
                if (this.getModuleValue(`AlarmEntries[${i}].OUT_AlarmState`).value > 0) {
                    alarmStr += `🔴 ${this.getModuleValue(`AlarmEntries[${i}].CFG.alarmLabel`).value} `;
                }
            }
            return alarmStr;
        },
        orientationStr1: function () {
            return helpers.ventOrientation(this.getModuleValue('CFG.ausrichtung').value, 1);
        },
        orientationStr2: function () {
            return helpers.ventOrientation(this.getModuleValue('CFG.ausrichtung').value, 2);
        },
        currentStatusStr: function () {
            return this.getModuleValue('OUT_StatusStr').value;
        },
        currentPositionFloat1: function () {
            return parseFloat(this.getModuleValue('OUT_Stellung_1_Aktuell').value);
        },
        currentPositionFloat2: function () {
            return parseFloat(this.getModuleValue('OUT_Stellung_2_Aktuell').value);
        },
        pumpIcon: function () {
            if (this.getModuleValue('OUT_UWP').value === true) {
                return `pulse-loop fi-rr-arrow-circle-right fg-green`;
            } else {
                return `fi-rr-arrow-circle-right`;
            }
        },
        periodIndex: function () {
            return this.getModuleValue('OUT_AktPeriodeHzg.periodIndex').value;
        },
        periodCheck: function () {
            if (this.nodeDataPeriods.length > 0) {
                let cnt = 0;
                this.nodeDataPeriods.forEach((period) => {
                    const result = period.find(entry => entry.displayName === 'periodEnable');
                    if (result) {
                        if (result.value === true) cnt+=1;
                    }
                });
                if (cnt > 0) return false;
            }
            return true;
        },
    },
    data() {
        return {
            loading: false,
            showChart1: false,
            showChartValve: false,
            showChartPump: false,
            saveWait: false,
            dialogLoading: false,
            entryDialog: false,
            valveDialog: false,
            ioDialogData: {},
            ioObj: {},
            timeSetGrp: null,
            nodeData: [],
            nodeDataOld: [],
            nodeDataCfg: [],
            nodeDataCfgOld: [],
            nodeDataPeriods: [],
            nodeDataPeriodsOld: [],
            showDiagName: false,
            diagPeriod: 0,
            currentGrp: {
                name: null,
                label: null,
                enable: null,
                timeSet: null,
                limits: {},
                controller: {},
            },
            node: null,
            lala: null,
            loadDiagPeriods: false,
            showDiagPeriods: false,
            loadDiagMisc: false,
            showDiagMisc: false,
            submitted: false,
            selectedKey: {},
            expandedKeys: {},
            items: [],
            items1: [
                {
                    label: 'VL-Perioden',
                    icon: 'fi fi-rr-settings',
                    command: () => {
                        // this.editEntry(this.content);
                        this.toggleOP(null, 'periods');
                    },
                },
                {
                    label: 'Allgemeine Einstellungen',
                    icon: 'fi fi-rr-settings-sliders',
                    command: () => {
                        // this.editValve(this.content);
                        this.toggleOP(null, 'misc');
                    },
                },
            ],
            items2: [
                {
                    separator: true,
                },
                {
                    label: 'Widget Config',
                    icon: 'pi pi-cog',
                    command: () => {
                        this.editEntry(this.content);
                    },
                },
                {
                    label: 'Duplizieren',
                    icon: 'pi pi-clone',
                    command: () => {
                        this.duplicateEntry();
                    },
                },
                {
                    label: 'Löschen',
                    icon: 'pi pi-times',
                    command: () => {
                        this.deleteEntry();
                    },
                },
            ],
        };
    },
    created() {
        this.loading = true;
    },
    mounted() {
        this.checkEditMode();
        if (!this.getModuleFetched(this.moduleHash)) {
            this.loadModule(this.connectedModule).then((module) => {
                const moduleHash = `${module.source.server}@${module.source.identifier}.*`;
                SocketioService.getRedisNodesParam(moduleHash, (err, response) => {
                    if (!err && response) {
                        if (Array.isArray(response) && response.length > 0) {
                            this.setNodesFull(response);
                        }
                    }
                }).then(() => { 
                    if (this.editMode) console.log(`[ENATWIDGET] ${this.moduleHash} : component ready!`);
                    this.setModuleFetched(this.moduleHash);
                    this.loading = false;
                });
            });
        } else {
            this.loading = false;
        }
    },
    methods: {
        ...mapActions({
            loadNode: 'opcua/loadNode',
            loadModule: 'opcua/loadModule',
            setNodesFull: 'opcua/setNodesFull',
            setModuleFetched: 'opcua/setModuleFetched',
        }),
        loadingState(state) {
            if (state) {
                this.loading = true;
            } else {
                this.loading = false;
            }
        },
        getModuleValue(schemeEntry) {
            const key = `${this.moduleHash}.${schemeEntry}`;
            return this.getNode(key);
        },
        getModuleValueStr(schemeEntry) {
            const key = `${this.moduleHash}.${schemeEntry}`;
            const node = this.getNode(key);
            if (typeof node.unit === 'string' && node.unit.length > 0) {
                return `${node.value}${node.unit}`;
            }
            return `${node.value}`;
        },
        getDiagData(key) {
            if (this.nodeData.length > 0) {
                const result = this.nodeData.find(entry => entry.key2 === key);
                return result;
            }
            return null;
        },
        getDiagDataPeriods(index, displayName) {
            if (this.nodeDataPeriods.length > 0 && index >= 0) {
                const result = this.nodeDataPeriods[index].find(entry => entry.displayName === displayName);
                return result;
            }
            return null;
        },
        getDiagDataCfg(displayName) {
            if (this.nodeDataCfg.length > 0 && displayName) {
                const result = this.nodeDataCfg.find(entry => entry.displayName === displayName);
                return result;
            }
            return null;
        },
        watchCreatedLayout() {
            // this.loading = true;
        },
        watchLayout() {
        },
        checkEditMode() {
            if (this.$store.getters.getPageData.editMode) {
                this.items = [...this.items1, ...this.items2];
            } else {
                this.items = [...this.items1];
            }
        },
        clearVals() {
            this.nodeDataCfg = [];
            this.nodeDataCfgOld = [];
            this.nodeDataPeriods = [];
            this.nodeDataPeriodsOld = [];
            this.saveWait = false;
            this.dialogLoading = false;
            this.diagPeriod = 0;
        },
        updateMap() {
            // this.node = helpers.mapNodes(_.cloneDeep(this.nodeEntry.children), null);
            if (this.node && this.node.size > 0) {
                for (let [key, element] of this.node) {
                    const child = store.getters.getMapValue(element.uuid);
                    this.node.set(key, {...child, value: child.value});
                }
            }
        },
        currentMap() {
            let map = new Map();
            if (this.node && this.node.size > 0) {
                for (let [key, element] of this.node) {
                    const child = store.getters.getMapValue(element.uuid);
                    map.set(key, {...child, value: child.value});
                }
                return map;
            }
            return null;
        },
        getParameter(lvl1, lvl2, index) {
            let parameter = null;
            if (!lvl1) return false;
            if (!lvl2) lvl2 = '';
            if (!isNaN(index)) {
                parameter = this.node.get(lvl1 + '[' + index + '].' + lvl2);
            } else {
                parameter = this.node.get(lvl1 + lvl2);
            }
            return parameter;
        },
        returnChild(childStr) {
            if (typeof childStr == 'string' && this.nodeEntry !== undefined) {
                return helpers.returnChild(this.nodeEntry, childStr);
            } else {
                return null;
            }
        },
        returnParameter(node, key, parameter) {
            return helpers.returnParameter(node, key, parameter);
        },
        returnParameterValue(node, key, parameter, unit) {
            return helpers.returnParameterValue(node, key, parameter, unit);
        },
        timeDialog(time) {
            console.log(time);
        },
        toogleAlarmOverlay(event) {
            this.$refs.alarmOverlay.toggle(event);
        },
        toggle(event) {
            this.$refs.menu.toggle(event);
            // this.this.getModuleValueStatusIOTree();
            // this.getOPCAppTree();
        },
        toggleOP(event, grp) {
            if (grp === 'periods') {
                this.loadDiagPeriods = true;
                SocketioService.getRedisNodesParamScaled(`${this.moduleHash}.CFG.periods*`, (err, response) => {
                    if (err || !response) {
                        console.log(`[ENATWIDGET] error fetching params: ${err}`);
                    }
                    else {
                        if (Array.isArray(response) && response.length > 0) {
                            let tmpNodes = [];
                            tmpNodes = JSON.parse(JSON.stringify(response));
                            tmpNodes.forEach((entry) => {
                                if (entry.child1) {
                                    const child = JSON.parse(entry.child1)
                                    if (child.index >= 0) {
                                        if (!Array.isArray(this.nodeDataPeriods[child.index])) {
                                            this.nodeDataPeriods[child.index] = [];
                                        }
                                        this.nodeDataPeriods[child.index].push(entry);
                                    }
                                }
                                // console.log(entry);
                            });
                            this.nodeDataPeriodsOld = JSON.parse(JSON.stringify(this.nodeDataPeriods));
                            console.log(this.nodeDataPeriods);
                            console.log(this.nodeDataPeriodsOld);
                            // console.log(this.getDiagDataHzg(0, 'periodName'));
                        }
                    }
                }).then(() => {
                    this.loadDiagPeriods = false;
                    this.showDiagPeriods = true;
                });        
            } else if (grp === 'periodsVents') {
                SocketioService.getRedisNodesParamScaled(`${this.moduleHash}.Perioden_Lueftung*`, (err, response) => {
                    if (err || !response) {
                        console.log(`[ENATWIDGET] error fetching params: ${err}`);
                    }
                    else {
                        if (Array.isArray(response) && response.length > 0) {
                            let tmpNodes = [];
                            tmpNodes = JSON.parse(JSON.stringify(response));
                            tmpNodes.forEach((entry) => {
                                if (entry.child0) {
                                    const child = JSON.parse(entry.child0)
                                    if (child.index >= 0) {
                                        if (!Array.isArray(this.nodeDataLft[child.index])) {
                                            this.nodeDataLft[child.index] = [];
                                        }
                                        this.nodeDataLft[child.index].push(entry);
                                    }
                                }
                                // console.log(entry);
                            });
                            this.nodeDataLftOld = JSON.parse(JSON.stringify(this.nodeDataLft));
                            console.log(this.nodeDataLft);
                            console.log(this.nodeDataLftOld);
                            // console.log(this.getDiagDataHzg(0, 'periodName'));
                        }
                    }
                }).then(() => {
                    this.showDiagVents = true;
                }); 
            } else if (grp === 'misc') {
                this.loadDiagMisc = true;
                SocketioService.getRedisNodesParamScaled(`${this.moduleHash}.CFG*`, (err, response) => {
                    if (err || !response) {
                        console.log(`[ENATWIDGET] error fetching params: ${err}`);
                    }
                    else {
                        if (Array.isArray(response) && response.length > 0) {
                            this.nodeDataCfg = JSON.parse(JSON.stringify(response));
                            this.nodeDataCfgOld = JSON.parse(JSON.stringify(response));
                        }
                            console.log(this.nodeDataCfg);
                            console.log(this.nodeDataCfgOld);
                            // console.log(this.getDiagDataHzg(0, 'periodName'));
                        }
                }).then(() => {
                    this.loadDiagMisc = false;
                    this.showDiagMisc = true;
                }); 
            }
        },
        diagTogglePeriods() {
            if (this.showDiagPeriods) {
                this.showDiagPeriods = false;
            } else {
                this.showDiagPeriods = true;
            }
            this.hideOP();
        },
        diagToggleMisc() {
            if (this.showDiagMisc) {
                this.showDiagMisc = false;
            } else {
                this.showDiagMisc = true;
            }
            this.hideOP();
        },
        hideOP() {
            this.clearVals();
        },
        saveDiag(diag) {
            if (diag) {
                const saveArray = [];
                this.dialogLoading = true;
                this.saveWait = true;

                if (diag === 'periods' && !this.periodCheck) {
                    console.log(this.nodeDataPeriods);
                    console.log(this.nodeDataPeriodsOld);
                    const flatHzg = this.nodeDataPeriods.flatMap(innerArr => innerArr);
                    const flatHzgOld = this.nodeDataPeriodsOld.flatMap(innerArr => innerArr);
                    console.log(flatHzg);
                    console.log(flatHzgOld);

                    flatHzg.forEach((obj1) => {
                    // Find the corresponding object in arr2
                    const obj2 = flatHzgOld.find((item) => item.identifier === obj1.identifier);
                    
                    // If the object is found, compare the values
                    if (obj2) {
                        if (obj1.value !== obj2.value) {
                            const entry = parseNode(obj1, true);
                            saveArray.push(entry);
                        } else if ('plusminus' in obj2 && 'plusminus' in obj1) {
                            if (obj2.plusminus !== obj1.plusminus) {
                                const entry = parseNode(obj1, true);
                                saveArray.push(entry);
                            }
                        }
                    }
                    });
                } else if (diag === 'periodsLft') {
                    console.log(this.nodeDataLft);
                    console.log(this.nodeDataLftOld);
                    const flatHzg = this.nodeDataLft.flatMap(innerArr => innerArr);
                    const flatHzgOld = this.nodeDataLftOld.flatMap(innerArr => innerArr);
                    console.log(flatHzg);
                    console.log(flatHzgOld);

                    flatHzg.forEach((obj1) => {
                    // Find the corresponding object in arr2
                    const obj2 = flatHzgOld.find((item) => item.identifier === obj1.identifier);
                    
                    // If the object is found, compare the values
                    if (obj2) {
                        if (obj1.value !== obj2.value) {
                            const entry = parseNode(obj1, true);
                            saveArray.push(entry);
                        } else if ('plusminus' in obj2 && 'plusminus' in obj1) {
                            if (obj2.plusminus !== obj1.plusminus) {
                                const entry = parseNode(obj1, true);
                                saveArray.push(entry);
                            }
                        }
                    }
                    });
                } else if (diag === 'misc') {
                    console.log(this.nodeDataCfg);
                    console.log(this.nodeDataCfgOld);
                    this.nodeDataCfg.forEach((obj1) => {
                    // Find the corresponding object in arr2
                    const obj2 = this.nodeDataCfgOld.find((item) => item.identifier === obj1.identifier);
                    
                    // If the object is found, compare the values
                    if (obj2) {
                        if (obj1.value !== obj2.value) {
                            const entry = parseNode(obj1, true);
                            saveArray.push(entry);
                        } else if ('plusminus' in obj2 && 'plusminus' in obj1) {
                            if (obj2.plusminus !== obj1.plusminus) {
                                const entry = parseNode(obj1, true);
                                saveArray.push(entry);
                            }
                        }
                    }
                    });
                }
                
                // console.log(saveArray);
                if (saveArray.length > 0) {
                    SocketioService.setOpcValue(saveArray, (err, response) => {
                        if (err) {
                            console.log(err);
                        } else {
                            console.log(response);
                            setOpcValueToast(response, this.$root);
                            this.dialogLoading = false;
                            if (diag === 'periods') this.showDiagPeriods = false;
                            if (diag === 'misc') this.showDiagMisc = false;
                            this.hideOP();
                        }
                    });
                } else {
                    if (diag === 'periods' && !this.periodCheck) {
                        this.saveDiagNoChanges();
                        this.showDiagPeriods = false;
                    } else if (diag === 'periods' && this.periodCheck) {
                        this.saveDiagNoPeriods();
                    } else if (diag === 'misc') {
                        this.saveDiagNoChanges();
                        this.showDiagMisc = false;
                    }
                }
            }
        },
        saveDiagNoChanges() {
            setOpcValueToast(null, this.$root);
            this.dialogLoading = false;
            this.hideOP();
        },
        saveDiagNoPeriods() {
            this.$toast.add({
                severity: 'warn',
                summary: 'Eine Periode aktivieren!',
                detail: 'Es muss zumindest eine Periode aktiviert werden.',
                life: 3000,
            });
            this.dialogLoading = false;
            this.saveWait = false;
        },
        toogleNameDiag(name) {
            this.changeDiagName = JSON.parse(JSON.stringify(name));
            this.showDiagName = true;
        },
        hideNameDiag() {
            this.changeDiagName = null;
            this.showDiagName = false;
        },
        saveNameDiag(node) {
            console.log(node);
            if (node.child1) {
                const child = JSON.parse(node.child1);
                if (child.index >= 0) {
                    console.log(child.index)
                    let obj2 = null;
                    obj2 = this.nodeDataPeriods[child.index].find((item) => item.identifier === node.identifier);
                    if (obj2) {
                        if (typeof this.changeDiagName.value === 'string' && this.changeDiagName.value.length > 0) {
                            obj2.value = this.changeDiagName.value;
                        }
                        console.log(obj2);
                    }
                }
            }
            this.hideNameDiag();
        },
        focusElement(event) {
            if (event !== undefined) {
                event.target.select();
            }
        },
        hideDialog() {
            this.entryDialog = false;
            this.submitted = false;
            // clearInterval(this.intval_Value);
            // this.getUserList();
        },
        resetDialogData() {
            this.ioDialogData = {
                style: {},
                components: {},
                data: {},
            };
            this.selectedKey = {};
            this.expandedKeys = {};
        },
        changeVal(ioData) {
            console.log(ioData);
            this.$emit('entrySave', ioData);
        },
        editEntry(ioData) {
            this.ioDialogData = JSON.parse(JSON.stringify(ioData));
            this.ioObj = JSON.parse(JSON.stringify(this.moduleData));
            this.entryDialog = true;
        },
        saveDialog() {
            this.submitted = true;
            if (this.ioDialogData.i) {
                this.$emit('entrySave', this.ioDialogData);
                this.entryDialog = false;
                this.resetDialogData();
            }
        },
        duplicateEntry() {
            this.$emit('entryDuplicate', this.content);
            this.resetDialogData();
        },
        deleteEntry() {
            this.$emit('entryDelete', this.content);
            this.resetDialogData();
        },
        expandNode(node) {
            this.expandedKeys[node.key] = true;
            if (node.children && node.children.length) {
                for (let child of node.children) {
                    this.expandNode(child);
                    if (child.key === this.ioObj._id) {
                        this.selectedKey[this.ioObj._id] = true;
                    }
                }
            }
        },
        onNodeSelect(node) {
            const newObj = store.getters.getValue(node.key);
            this.selectedKey = node.key;
            this.ioDialogData.data.id = node.key;

            this.$toast.add({
                severity: 'success',
                summary: 'Node ausgewählt',
                detail: newObj.metadata.name + '\n' + this.selectedKey + '\n' + newObj.nodeId,
                life: 3000,
            });
        },
        editValve(ioData) {
            console.log(ioData);
        },
        hideValveDialog() {
            this.valveDialog = false;
            this.submitted = false;
            // clearInterval(this.intval_Value);
            // this.getUserList();
        },
        focusDiag(event) {
            this.periodDiagDelay(event);
        },
        periodDiagDelay(event) {
            setTimeout(() => {
                this.diagPeriod = this.getModuleValue('OUT_CurrentPeriod.periodIndex').value;
                this.focusElement(event);
            }, 300);
        },
        showChart(value) {
            if (value === 'value1') this.showChart1 = true;
            else if (value === 'valve') this.showChartValve = true;
            else if (value === 'pump') this.showChartPump = true;
        },
    },
});
</script>

<style lang="scss" scoped>
.bounce-enter-active {
    animation: bounce-in 0.5s;
    // transition: opacity .5s;
}

.bounce-leave-active {
    animation: bounce-out 0.5s;
    // transition: opacity .5s;
}

.slide-fade-enter-active {
    transition: all 0.5s ease;
}

.slide-fade-leave-active {
    transition: all 0.8s cubic-bezier(1, 0.5, 0.8, 1);
}

.slide-fade-enter,
.slide-fade-leave-to

/* .slide-fade-leave-active for <2.1.8 */
    {
    transform: translateX(10px);
    opacity: 0;
}

.pulse-enter-active {
    animation: pulse 1s;
}

.pulse-leave-active {
    animation: pulse 0.5s;
}

.pulse-loop {
    animation: pulse 1s;
    animation-iteration-count: infinite;
}

.fade-in-enter-active {
    animation: fadeIn linear 2s;
}

.fade-in-leave-active {
    animation: fadeOut linear 2s;
}

@keyframes fadeIn {
    0% {
        opacity: 0;
    }

    100% {
        opacity: 1;
    }
}

@keyframes fadeOut {
    0% {
        opacity: 1;
    }

    100% {
        opacity: 0;
    }
}

@keyframes fadeInOut {
    0% {
        // opacity: 0;
    }
    50% {
        // opacity: 1;
        background-color: rgba(117, 18, 0, 0.5);
    }
    100% {
        // opacity: 0;
    }
}

@keyframes pulse {
    0% {
        // transform: scale(1); /* scaling to 0 */
        opacity: 0.8;
        // color: yellowgreen;
        // transform-origin: center center;
        // transform: scaleY(.9);
        text-shadow: black 2px 0 10px;
        transform: scale(0.9);
        /* increasing the size */
    }

    30% {
        transform: scale(1.1);
        /* increasing the size */
        text-shadow: gray 1px 0 10px;
    }

    100% {
        transform: scale(1);
        /* seeting back to initial size */
        opacity: 1;
    }
}

.alarm {
    animation: fadeInOut 1s infinite;
    -webkit-animation: fadeInOut 1s infinite;
}

.grid {
    margin: 0 -0.5em 0 -0.5em !important;
}

.col {
    // line-height: 1.4em !important;
    margin: 0 !important;
    padding: 0 !important;
}

.p-divider {
    margin: 0 !important;
    padding: 0 !important;
}

.box {
    overflow: hidden;
    // text-shadow: 1px 1px 1px black;
}

.card {
    font-family: 'SensorFont';
    line-height: 1.3rem;
    position: relative;
}

.text-normal {
    line-height: 0;
}
// .list-enter-active,
// .list-leave-active {
//   transition: all 0.5s ease;
//   transform: scale(0.7); /* increasing the size */
// }
// .list-enter-from,
// .list-leave-to {
//   opacity: 0;
//   transform: scale(1); /* increasing the size */
// }
.list-enter-active {
    animation: list 1s;
}

.list-leave-active {
    animation: list 0.5s;
}

@keyframes list {
    0% {
        opacity: 0;
    }

    100% {
        opacity: 1;
    }
}
.p-togglebutton {
    font-size: 0.8rem;
    line-height: 1rem;
    padding: 0.2rem;
    margin: 0;
}
</style>